export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Escrime XXI N⁰. 109",
    "shortTitle": "",
    "description": "",
    "width": 1532,
    "height": 1150,
    "currentLanguage": "ES",
    "languages": [{
      "code": "EN",
      "text": "English",
      "href": "http://escrime-xxi.fie.org/109/en/"
    },
    {
      "code": "FR",
      "text": "French",
      "href": "http://escrime-xxi.fie.org/109/fr/"
    },
    {
      "code": "ES",
      "text": "Spanish",
      "href": "http://escrime-xxi.fie.org/109/es/"
    }],
    "basePath": "/109/es",
    "companyLogo": "1-title.png",
    "publishURL": "http://escrime-xxi.fie.org/109/es/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "downloadPath": '',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "mobileSwitch": true,
      "guideEnabled": false,
      "galleryCaptions": {},
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `

        <img id="1-0" class="halfScale" style="top:0px;left:371px" src="/109/es/static/_content/1-x.png">
        
        <img id="1-1" class="halfScale" style="top:110px;left:68px" src="/109/es/static/_content/1-title.png">
        <img id="1-2" class="halfScale" style="top:276px;left:66px" src="/109/es/static/_content/1-sub-1.png">

        <img id="1-3" class="halfScale" style="top:111px;left:1075px" src="/109/es/static/_content/1-no.png">

        <img id="1-text-1" class="halfScale pointer" style="top:336px;left:788px" onclick="Publish.goToPage(44)" src="/109/es/static/_content/1-sub-2.png">
        <img id="1-text-2" class="halfScale pointer" style="top:547px;left:1149px" onclick="Publish.goToPage(49)" src="/109/es/static/_content/1-sub-3.png">
        <img id="1-text-3" class="halfScale pointer" style="top:786px;left:1045px" onclick="Publish.goToPage(8)" src="/109/es/static/_content/1-sub-4.png">

        <img id="1-4" class="halfScale pointer" style="top:989px;left:1441px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/1-arrow.png">

      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim
          .fromTo(idOf("1-1"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)
          .fromTo(idOf("1-0"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},"-=0.2")
          .fromTo(idOf("1-2"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-3"), 0.5, {y: 30, opacity:0}, {y: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-text-1"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-text-2"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-text-3"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-4"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1})
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "N˚109 REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  JUNIOR Y CADETES CAMPEONATOS DEL MUNDO  YUKA UENO LA ESTRELLA EN ALZA GRAN PREMIO DOHA A EL CAIRO Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista",
      "mobileHtml": `
      <img src="/109/es/static/_mobile/mobile-cover.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `

      <img class="halfScale 2-title" style="top:108px;left:80px" src="/109/es/static/_content/2-title.png">

      <img class="halfScale 2-icons" style="top:862px;left:156px" src="/109/es/static/_content/2-pop.png">
      <img class="halfScale 2-icons" style="top:862px;left:458px" src="/109/es/static/_content/2-play.png">
      <img class="halfScale 2-icons" style="top:863px;left:829px" src="/109/es/static/_content/2-social.png">
      <img class="halfScale 2-icons" style="top:863px;left:1152px" src="/109/es/static/_content/2-numbers.png">

      <img class="halfScale pointer howto-desktop" style="top:125px;left:1074px;opacity:1;" onclick="switchPopHowto(true)" src="/109/es/static/_content/2-btn-desktop.png">
      <img class="halfScale pointer howto-ipad" style="top:125px;left:1276px;opacity:0" onclick="switchPopHowto(false)" src="/109/es/static/_content/2-btn-ipad.png">

      <img class="halfScale howto-desktop" style="top:256px;left:84px;" src="/109/es/static/_content/2-desktop.png">
      <img class="halfScale howto-ipad" style="top:250px;left:69px;display:none;" src="/109/es/static/_content/2-ipad.png">

      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax()
          pg2Anim.fromTo(cOf("2-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .staggerFromTo(cOf("2-icons"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, onComplete: addContentLinks}, 0.3, "-=0.2")
        }

        function switchPopHowto(bool){
          if(bool){
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-ipad")[0].style.opacity = 0;
              cOf("howto-ipad")[1].style.display = "none";
            }});
            cOf("howto-desktop")[0].style.opacity = 1;
            cOf("howto-desktop")[1].style.display = "block";
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
          }else{
            cOf("howto-ipad")[0].style.opacity = 1;
            cOf("howto-ipad")[1].style.display = "block";
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-desktop")[0].style.opacity = 0;
              cOf("howto-desktop")[1].style.display = "none";
            }});
          }
        }

        function onPageLeave() {
          pg2Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": "INSTRUC CIONES DE USO  Haga clic para cambiar la vista  INSTRUCCIONES DE USO  IPAD  ESCRITORIO  Escrime XXI  La revista de esgrima utiliza la última tecnología digital. Presentamos algunas características de uso para disfrutar de la publicación.  C ONOZCA A LOS ATLE TAS  EXPLORAR Utilice las flechas del teclado para desplazarse horizontalmente por la revista  Navegación  Para ver la revista, utilice las flechas del teclado para desplazarse a la izquierda y a la derecha por toda la publicación.  YUKA UENO  EXPLORADOR DE INTERNET Para obtener los mejores resultados, recomendamos el uso de Safari o Google Chrome.  EXPLORAR  r… Zonas interactivas en el interio  1 2 3 ELEMENTOS EMERGENTES  BOTÓN DE REPRODUCCIÓN  REDES SOCIALES  NÚMEROS  Pulse para mostrar u ocultar retazos de información.  En esta revista encontrará vídeos fantásticos. Pulse este botón para disfrutar de ellos.  Pulse los iconos de las redes sociales que encontrará por toda la revista.  Pulse los botones para mostrar más contenidos apasionantes.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:25px;right:40px;width:280px; height:30px;">
          <a href="https://www.tissotwatches.com/es-es/homepage" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.tissotwatches.com" target="_blank">
        <img src="/109/es/static/_mobile/3.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `

        <a href="http://fie.org/es?no-redirect=" target="_blank">
            <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <div class="addContentLink" style="top: 191px; left:80px;width:145px; height: 35px;">
          <a href="http://fie.org/es?no-redirect=" target="_blank"></a></div>

        <div class="addContentLink" style="top: 75px; right:623px;width:55px; height: 55px;">
          <a href="https://www.facebook.com/fie.org" target="_blank"></a></div>

        <div class="addContentLink" style="top:130px; right:623px;width:55px; height: 55px;">
          <a href="https://twitter.com/FIE_fencing" target="_blank"></a></div>

        <img id="4-title" class="halfScale" style="top:81px;left:80px" src="/109/es/static/_content/4-title.png">

        <img id="fourIpad" class="halfScale fourIpad" style="top:384px;left:594px" src="/109/es/static/_content/4-ipad.png">

        <img class="cont-item cont-item-1-btn halfScale" style="top:327px;left:572px;opacity:0" src="/109/es/static/_content/4-edit.jpg">
        <img class="cont-item cont-item-2-btn halfScale" style="top:338px;left:575px;opacity:0" src="/109/es/static/_content/4-sport.jpg">
        <img class="cont-item cont-item-3-btn halfScale" style="top:358px;left:574px;opacity:0" src="/109/es/static/_content/4-prev.jpg">
        <img class="cont-item cont-item-4-btn halfScale" style="top:351px;left:574px;opacity:0" src="/109/es/static/_content/4-int.jpg">
        <img class="cont-item cont-item-5-btn halfScale" style="top:328px;left:574px;opacity:0" src="/109/es/static/_content/4-fie.jpg">
        <img class="cont-item cont-item-6-btn halfScale" style="top:357px;left:574px;opacity:0" src="/109/es/static/_content/4-news.jpg">

        <img id="4-next" class="halfScale pointer" style="top:940px;left:1408px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/4-arrow.png">

        <div class="addContentLink" onclick="contentsBub(1);" style="top:358px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(2);" style="top:452px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(3);" style="top:543px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(4);" style="top:635px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(5);" style="top:727px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(6);" style="top:819px; left:84px; width: 492px; height: 60px;"></div>

        <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)" style="top:357px;left:648px;width:568px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)" style="top:357px;left:648px;width:706px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(19)" style="top:450px;left:649px;width:706px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(44)" style="top:541px;left:648px;width:724px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(49)" style="top:634px;left:648px;width:532px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(52)" style="top:726px;left:648px;width:471px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(55)" style="top:817px;left:648px;width:471px;height:90px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(59); setTimeout(function(){showOverlay('59-pop-1');}, 200)" style="top:726px;left:648px;width:759px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(59); setTimeout(function(){showOverlay('59-pop-2');}, 200)" style="top:818px;left:648px;width:759px;height:64px;display:none;"></div>

      `,
      "script": `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        
        pg4Anim.fromTo(idOf("4-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)
        .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
  
  
      function contentsBub(index){
        TweenMax.to(cOf("cont-hide"), 0.5, {opacity:0})
        console.log("contentsBub", index)
        for(var i=1; i <= 8; i++){
          if(i == index){
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
              console.log(c)
              c.style.display = "";
            },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:1, onComplete:function(){
              /*
              classc("cont-item-"+index+"-link")[0].style.display = ""
              if(classc("cont-item-"+index+"-link")[1]){
                classc("cont-item-"+index+"-link")[1].style.display = ""        
              }
              */
            }});
          }else{
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                c.style.display = "none";
              },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:0});
            TweenMax.to(cOf("fourIpad"), 0.5, {opacity:0});
          }
        }
      }
  
      function onPageLeave() {
        pg4Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "ÍNDICE  EN ESTE NÚMERO  Le damos la bienvenida a la última edición de Escrime XXI, que llega repleta de las mejores imágenes, vídeos y artículos del mundo de la esgrima, y presenta una imagen totalmente fresca y renovada.  WWW.FIE.ORG  EDITORIAL  DEPORTE  Pulse los botones para revelar el contenido  VISTA PREVIA N˚109  ENTREVISTA  REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  NOTICIAS DE LA FIE Y DE LAS FEDERACIÓNES NACIONALES  NOTICIAS  JUNIOR Y CADETES CAMPEONATOS DEL MUNDO  YUKA UENO LA ESTRELLA EN ALZA GRAN PREMIO DOHA A EL CAIRO Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `

      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>

      <img class="halfScale pointer 5-arrow" style="top:854px;left:1387px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/5-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1013px;left:54px" src="/109/es/static/_content/5-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1013px;left:124px" src="/109/es/static/_content/5-social-fb.png">
      </a>
      <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1013px;left:192px" src="/109/es/static/_content/5-social-yt.png">
      </a>

      <div class="addContentLink" style="bottom:242px;left:745px;width:100px;height:26px;">
        <a href="mailto:info@fie.ch"></a>
      </div>
        <div class="addContentLink" style="bottom:213px;left:686px;width:105px;height:26px;">
          <a href="http://fie.org/es?no-redirect=" target="_blank"></a>
      </div>
        <div class="addContentLink" style="bottom:154px;right:308px;width:212px;height:30px;">
          <a href="http://www.touchline.com" target="_blank"></a>
      </div>
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax()
          pg5Anim.fromTo(cOf("5-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg5Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": "C OMITÉ E JECUTIVO DE L A FIE  Presidente: Alisher Usmanov (RUS) Secretario general: Emmanuel Katsiadakis (M.H.) (GRE) Secretaria tesorera: Ferial Nadira Salhi (ALG)  OFICINA CENTRAL DE LA FIE  Vicepresidentes: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Miembros: Erika Aze (LAT) Jacek Bierkowski (POL) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX) Wei Wang (CHN) Aldo Montano Presidente de la Comisión de Atletas de la FIE (ITA)  Administración  Directora general Nathalie Rodriguez M.-H. (FRA)  Directora administrativa: Elena Murdaca (ITA) Gestora de contabilidad: Sandra Baroni (SUI) Asistente de dirección: Gabrielle Meylan (BRA) Asistente administrativa: Ylenia Murdaca (ITA) Jefe de operaciones: Elena Huot (RUS) Deporte  Director técnico y deportivo: Evgeny Tsoukhlo (RUS)  Manager de la tecnología y de la administración del deporte: Natalia Bodrova (RUS) Manager de operaciones del deporte: Sophie Treyvaud (SUI) Comunicación, Marketing, TV  Presidente de la Confederación Africana de Esgrima: Mbagnick Ndiaye (SEN) Presidente de la Confederación Panamericana de Esgrima: Vitaly Logvin (MEX) Presidente de la Confederación Asiática de Esgrima: Celso L. Dayrit (M.H.) (PHI) Presidente de la Confederación Europea de Esgrima: Stanislav Pozdnyakov (RUS) Presidente de la Confederación Oceánica de Esgrima: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Jefe del gabinete del presidente: Nina Lalovic (SRB)  Manager digital y de comunicaciónes: Maria Ntanou (GRE)  Jefe de producción TV de la FIE: Barna Heder (HUN)  Asistente de producción TV de la FIE: Svetlana Krasnokoutskaya (RUS) Encargado de prensa: Serge Timacheff (USA) Fotógrafo: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG",
      "mobileHtml": `
        <p>
        <b>President</b>:<br> Alisher Usmanov (RUS)<br>
        <b>Secretary General</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>
        <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>
        <p>
        <b>Vice Presidents</b>:<br>
        Ana Pascu (M.H.) (ROU)<br>
        Donald Anthony (USA)<br>
        Yuki Ota (JPN)<br></p>
        <p>
        <b>Members</b>:<br>
        Erika Aze (LAT)<br>
        Jacek Bierkowski (POL)<br>
        Velichka Hristeva (BUL)<br>
        Isabelle Lamour (FRA)<br>
        Novak Perovic (RSA)<br>
        Oleg Peskov (KAZ)<br>
        Giorgio Scarso (ITA)<br>
        Bence Szabo (HUN)<br>
        Pascal Tesch (LUX)<br>
        Wei WANG (CHN)<br>
        Aldo Montano President of the FIE athletes commission (ITA)<br></p>

        <p>
          <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>
          <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>
          <b>President, Asian Fencing Confederation</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>
          <b>President, European Fencing Confederation</b>: <br>Stanislav Pozdnyakov (RUS)<br>
          <b>President, Oceanian Fencing Confederation</b>: <br>Helen Smith (M.H.) (AUS)<br>
        </p>
        
        <h2>FIE Head Office</h2>
        <p>
        <b>Chief Executive Officer</b><br>
        Nathalie Rodriguez M.-H. (FRA)
        </p>

        <h2>Administration</h2>
        <p>
        <b>Administration Director</b>:<br> Elena Murdaca (ITA)<br>
        <b>Accounting Manager</b>:<br> Sandra Baroni (BUL) <br>
        <b>Assistant to the Director</b>:<br> Gabrielle Meylan (BRA)<br>
        <b>Administrative Assistant</b>:<br> Ylenia Murdaca (ITA)<br>
        <b>Head of Operations</b>:<br> Elena Huot (RUS)<br>
        </p>

        <h2>Sport</h2>
        <p>
        <b>Sport and Technical Director</b>:<br> Evgeny Tsoukhlo (RUS)<br>
        <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova (RUS)<br>
        <b>Sport Operation Manager</b>:<br>Sophie Treyvaud (SUI) <br>
        </p>
        <h2>Communication, Marketing, TV</h2>
        <p>
        <b>Head of FIE President's Cabinet</b>:<br> Nina Lalovic (SRB)<br>
        <b>Digital Communications Manager</b>:<br> Maria Ntanou (GRE)<br>
        <b>Head of FIE TV Production</b>:<br> Barna Heder (HUN) <br>
        <b>FIE TV Production Assistant</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>
        <b>Press Officer</b>:<br> Serge Timacheff (USA)<br>
        <b>Photographer</b>:<br> Augusto Bizzi (ITA)<br>
        </p>

        <h2>Design</h2>
        <p>
        Touchline </b><br>
        (<a href="http://www.touchline.com" target="blank">www.touchline.com</a>)
        </p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      
      "content": `
      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>

        <img id="6-img" class="halfScale" style="top:308px;left:457px" src="/109/es/static/_content/6-img.jpg">
        <img id="6-title" class="halfScale" style="top:719px;left:301px" src="/109/es/static/_content/6-title.png">

        <img id="6-text-1" class="halfScale" style="top:310px;left:784px" src="/109/es/static/_content/6-text-1.png">
        <img id="6-text-2" class="halfScale" style="top:310px;left:199px; opacity:0;" src="/109/es/static/_content/6-text-2.png">

        <img id="6-cta-1" class="halfScale pointer" style="top:820px;left:784px" onclick="toggleText6(false);" src="/109/es/static/_content/6-p1.png">
        <img id="6-cta-2" class="halfScale pointer" style="top:820px;left:1063px;opacity:0" onclick="toggleText6(true);" src="/109/es/static/_content/6-p2.png">

        <img id="6-next" class="halfScale pointer" style="top:938px;left:1387px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/6-arrow.png">
      `,
      "script": `
      function onPageEnter(){
        pg6Anim = new TimelineMax();
        pg6Anim.fromTo(idOf("6-img"), 0.5,{opacity:0}, {opacity:1},0.5)
            .fromTo(idOf("6-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},"-=0.2")
            .fromTo(idOf("6-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},"+=0.3")
      }

      function toggleText6(bool){
        var text1 = idOf("6-text-1");
        var text2 = idOf("6-text-2");
        
        if(!bool && text1.style.opacity == "0"){
          pg6Anim.play();
          TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:0}, {opacity:1});
        }else if(bool && text2.style.opacity == "0"){
          pg6Anim.pause();
          TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:1}, {opacity:0});
        }
      }

      function onPageLeave(){
        if(idOf("6-text-1").style.opacity == "0"){
          toggleText6(false);
        }
        pg6Anim.stop();
        removeContentLinks()
      }
      `,
      "searchText": "PRÓLO GO  Estimados compañeros tiradores: Tengo el placer de redactar una breve introducción para la próxima edición de la Revista de la FIE.  TODA LA ATENCIÓN EN LA ESGRIMA  Hemos entrado en el tercer año del cuatrienio olímpico. La FIE, la federación nacional, los tiradores y los entrenadores han centrado su atención en los Juegos Olímpicos de Tokio 2020, evento en el que, por primera vez en nuestra historia, los tiradores y los equipos nacionales competirán en doce pruebas tanto por equipos como individuales, que se celebrarán en las tres armas, en pruebas masculinas y femeninas. Este es el reconocimiento al desarrollo de nuestro amado deporte por parte  PÁGINA 1  PÁGINA 2  W W W.FIE .ORG",
      "mobileHtml":`
      <h2>TODA LA ATENCIÓN EN LA ESGRIMA</h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg6-fore.jpg">
      <p><b>Estimados compañeros tiradores:</b></p>
      <p>Tengo el placer de redactar una breve introducción para la próxima edición de la revista de la FIE.</p>
      <p>Hemos entrado en el tercer año del cuatrienio olímpico. La FIE, la federación nacional, los tiradores y los entrenadores han centrado su atención en los Juegos Olímpicos de Tokio 2020, evento en el que, por primera vez en nuestra historia, los tiradores y los equipos nacionales competirán en doce pruebas tanto por equipos como individuales, que se celebrarán en las tres armas, en pruebas masculinas y femeninas.  Este es el reconocimiento al desarrollo de nuestro amado deporte por parte del Comité Olímpico Internacional. Es nuestro gran logro, pero también representa el mayor desafío para todos nosotros.</p>
      <p>En nuestro mundo en rápida evolución, estaremos preparados y dispuestos a seguir adaptándonos y progresando, a adoptar nuevas tendencias y a animarnos para un cambio. Nos centraremos en atraer a nuevos públicos, a más espectadores y aficionados a nuestras competencias; en implicar a nuevas personas, y en hacer que la esgrima sea más popular entre los niños y los adolescentes. Hace solo unos años nos centramos en hacer la esgrima más atractiva para la televisión. Ahora nuestro mayor desafío es lograr que la esgrima sea más popular en el mundo digital y en las redes sociales. Esta es nuestra principal misión para 2019.</p>
      <p>Tendremos una presencia igualmente sólida de jóvenes tiradores en los próximos Campeonatos del Mundo de Esgrima Juvenil y Cadete en Torun, junto con el Campeonato del Mundo de Esgrima Senior en Budapest. Además, con programas sólidos y eficaces como el «Donate Your Fencing Gear» de la FIE, que conecta a los atletas de élite con las federaciones emergentes y necesitadas, más tiradores de nuevas regiones están compitiendo a nivel local, nacional e internacional.</p>
      <p>Deseo que todos ustedes alcancen sus sueños de esgrima, y que todos nosotros consigamos que la esgrima sea aún más popular y atractiva.</p>
      <p><b>Alisher Usmanov<br>Presidente de la FIE</b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:80px;right:680px;width:480px; height:48px;">
          <a href="http://www.absolutefencinggear.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.absolutefencinggear.com">
        <img src="/109/es/static/_mobile/7.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 8-title" style="top:56px;left:978px" src="/109/es/static/_content/8-title.png">

      <img class="halfScale 8-line" style="top:611px;left:985px" src="/109/es/static/_content/8-line.png">

      <img class="halfScale 8-sub" style="top:612px;left:1027px" src="/109/es/static/_content/8-sub.png">

      <img class="halfScale pointer 8-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax()
          pg8Anim
            .fromTo(cOf("8-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("8-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("8-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("8-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg8Anim.stop()
        }
      `,
      "searchText": "GR AN PREMIO  BOREL Y BELJAJEVA GANAN LA MEDALLA DE ORO DEL GRAN PREMIO DE ESGRIMA DE ESPADA DOHA, CATAR 27 DE ENERO DE 2019",
      "mobileHtml":`
        <h2>BOREL Y BELJAJEVA GANAN LA MEDALLADE ORO DEL GRAN PREMIO DE ESGRIMA DE ESPADA</h2>
        <img id="fwdimg" src="/109/es/static/_mobile/pg8-doha.jpg">
        <p><b>DOHA, CATAR <br>
        27 DE ENERO DE 2019<br>
        </b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 9-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax()
          pg9Anim
            .fromTo(cOf("9-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg9Anim.stop()
        }
      `,
      "searchText": "GRAN PREMIO DOHA, CATAR 2/3  Más de 350 esgrimistas internacionales, hombres y mujeres, compitieron en Doha en el Gran Premio de espada de Catar de 2019, con dos campeones del mundo, el francés Yannick Borel y la estonia Julia Beljajeva, que se llevaron la medalla de oro. El Gran Premio de Catar es el primero de una serie de nueve que se celebrarán en todo el mundo a lo largo de la temporada 2018-2019 de la Federación Internacional de Esgrima (FIE). Tuvo lugar en la sala de «Aspire Zone» del Aspire Dome de Doha. Espada masculina En la competición individual masculina de espada, Borel se enfrentó al español Yulen Pereira y consiguió la medalla de oro con un resultado final de 15-4. Pereira derrotó al ucraniano Bogdan Nikishin en la semifinal, por 15-9, y Borel venció al estadounidense Jacob Hoyle, por 15-10. Cabe destacar que el campeón olímpico coreano Sangyoung Park perdió ante el francés Ronan Gustin en octavos de final por un solo toque, por 15-14. Gustin fue derrotado por Pereira en cuartos de final, por 15-12.",
      "mobileHtml":`
      <p><b>Más de 350 esgrimistas internacionales, hombres y mujeres, compitieron en Doha en el Gran Premio de espada de Catar de 2019, con dos campeones del mundo, el francés Yannick Borel y la estonia Julia Beljajeva, que se llevaron la medalla de oro.</b></p>
      <p>El Gran Premio de Catar es el primero de una serie de nueve que se celebrarán en todo el mundo a lo largo de la temporada 2018-2019 de la Federación Internacional de Esgrima (FIE). Tuvo lugar en la sala de «Aspire Zone» del Aspire Dome de Doha.</p>

      <p><b>Espada masculina</b></p>
      <p>En la competición individual masculina de espada, Borel se enfrentó al español Yulen Pereira y consiguió la medalla de oro con un resultado final de 15-4. Pereira derrotó al ucraniano Bogdan Nikishin en la semifinal, por 15-9, y Borel venció al estadounidense Jacob Hoyle, por 15-10. Cabe destacar que el campeón olímpico coreano Sangyoung Park perdió ante el francés Ronan Gustin en octavos de final por un solo toque, por 15-14. Gustin fue derrotado por Pereira en cuartos de final, por 15-12.</p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      
      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>

      <img class="halfScale pointer 10-arrow" style="top:846px;left:1388px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/10-arrow.png">
      
      <a href="https://fie.us15.list-manage.com/track/click?u=43e998d71622bc3f6aeddee10&id=1902386954&e=0ff8939683" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:754px;left:61px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      <a href="http://fie.org/" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:907px;left:59px" src="/109/es/static/_content/10-tap-info.png">
      </a>

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax()
          pg10Anim
            .fromTo(cOf("10-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)
        }

        function onPageLeave() {
          pg10Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "GRAN PREMIO DOHA, CATAR 3/3  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA  Pulse aquí para obtener más INFORMACIÓN  Espada femenina En la competición individual de espada femenina, Beljajeva se enfrentó a la ucraniana Kseniya Pantelyeyeva y ganó con un marcador final de 15-11. Para la ucraniana, fue la mejor final de su carrera. Se impuso a la rusa Violetta Kolobova en la semifinal, por 15-12, mientras que Beljajeva venció a la coreana Hyojung Jung, por 15-6. La actual campeona del mundo, la italiana Mara Navarria, perdió frente a Beljajeva en octavos de final, por 15-12.  Los ocho finalistas de espada individual masculina en el Gran Premio de Catar fueron Yannick Borel (FRA, oro), Yulen Pereira (ESP, plata), Jacob Hoyle (USA, bronce), Bogdan Nikishin (UKR, bronce), Roman Svichkar (UKR), Ronan Gustin (FRA), Ido Harper (ISR) y Sergey Bida (RUS). Las ocho finalistas femeninas fueron Julia Beljajeva (EST, oro), Kseniya Pantelyeyeva (UKR, plata), Hyojung Jung (KOR, bronce), Violetta Kolobova (RUS, bronce), Mingye Zhu (CHN), Ewa Trzebinska (POL), Pauline Brunner (SUI) y Yana Shemyakina (UKR). ■ W W W.FIE .ORG",
      "mobileHtml":`
      <p><b>Espada femenina</b></p>
      <p>En la competición individual de espada femenina, Beljajeva se enfrentó a la ucraniana Kseniya Pantelyeyeva y ganó con un marcador final de 15-11. Para la ucraniana, fue la mejor final de su carrera. Se impuso a la rusa Violetta Kolobova en la semifinal, por 15-12, mientras que Beljajeva venció a la coreana Hyojung Jung, por 15-6. La actual campeona del mundo, la italiana Mara Navarria, perdió frente a Beljajeva en octavos de final, por 15-12.</p>
      <p>Los ocho finalistas de espada individual masculina en el Gran Premio de Catar fueron Yannick Borel (FRA, oro), Yulen Pereira (ESP, plata), Jacob Hoyle (USA, bronce), Bogdan Nikishin (UKR, bronce), Roman Svichkar (UKR), Ronan Gustin (FRA), Ido Harper (ISR) y Sergey Bida (RUS).</p>
      <p>Las ocho finalistas femeninas fueron Julia Beljajeva (EST, oro), Kseniya Pantelyeyeva (UKR, plata), Hyojung Jung (KOR, bronce), Violetta Kolobova (RUS, bronce), Mingye Zhu (CHN), Ewa Trzebinska (POL), Pauline Brunner (SUI) y Yana Shemyakina (UKR).</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 11-title" style="top:109px;left:410px" src="/109/es/static/_content/11-title.png">

      <img class="halfScale 11-line" style="top:339px;left:416px" src="/109/es/static/_content/11-line.png">

      <img class="halfScale 11-sub" style="top:332px;left:458px" src="/109/es/static/_content/11-sub.png">

      <img class="halfScale pointer 11-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax()
          pg11Anim
          .fromTo(cOf("11-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("11-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("11-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("11-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg11Anim.stop()
        }
      `,
      "searchText": "GR AND PRIX  IMBODEN AND VOLPI TAKE FOIL GRAND PRIX GOLD TORINO, ITALY FEBRUARY 10, 2019",
      "mobileHtml":`
      <h2>IMBODEN Y VOLPI SE LLEVAN EL ORO EN LOS GRANDES PREMIOS DE FLORETE </h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg11-torino.jpg">
      <p><b>TURÍN, ITALIA<br>10 DE FEBRERO DE 2019<br>
      </b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 12-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
        `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax()
          pg12Anim
            .fromTo(cOf("12-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg12Anim.stop()
        }
      `,
      "searchText": "GRAN PREMIO TURÍN, ITALIA 2/3  Varios cientos de tiradores de florete internacionales masculinos y femeninos compitieron en los Grandes Premios de Florete de la FIE en Turín, Italia, donde Race Imboden de EE. UU. y Alice Volpi de Italia ganaron medallas de oro en las pruebas individuales.  La segunda de una serie de nueve pruebas de la competencia de esgrima de los Grandes Premios de la FIE, tuvo lugar en el Pala Alpitour de Turín (Palasport Olimpico), el mayor estadio deportivo cubierto de Italia y construido originalmente para los Juegos Olímpicos de Invierno de 2006. Florete masculino Imboden se enfrentó al hongkonés Ka Long Cheung en el encuentro final y venció con un resultado de 15-6. Compitieron aproximadamente 220 floretistas masculinos, entre ellos varios atletas campeones del mundo y olímpicos. En semifinales, Cheung derrotó al estadounidense Gerek Meinhardt, por 15-12, mientras que Imboden superó al campeón del mundo italiano Alessio Foconi por 15-13. Imboden también venció al campeón del mundo de Rusia Alexey Cheremisinov en cuartos de final, por 15-13. En particular, Meinhardt superó al campeón del mundo italiano Andrea Cassara en la ronda 16, por 15-13, y el vigente campeón olímpico italiano Daniele Garozzo fue derrotado en la ronda 32 por el polaco Michal Siess, por 15-7.",
      "mobileHtml":`
      <p><b>Varios cientos de tiradores de florete internacionales masculinos y femeninos compitieron en los Grandes Premios de Florete de la FIE en Turín, Italia, donde Race Imboden de EE. UU. y Alice Volpi de Italia ganaron medallas de oro en las pruebas individuales.</b></p>
      <p>La segunda de una serie de nueve pruebas de la competencia de esgrima de los Grandes Premios de la FIE, tuvo lugar en el Pala Alpitour de Turín (Palasport Olimpico), el mayor estadio deportivo cubierto de Italia y construido originalmente para los Juegos Olímpicos de Invierno de 2006.</p>
      <p><b>Florete masculino</b></p>
      <p>Imboden se enfrentó al hongkonés Ka Long Cheung en el encuentro final y venció con un resultado de 15-6. Compitieron aproximadamente 220 floretistas masculinos, entre ellos varios atletas campeones del mundo y olímpicos. En semifinales, Cheung derrotó al estadounidense Gerek Meinhardt, por 15-12, mientras que Imboden superó al campeón del mundo italiano Alessio Foconi por 15-13. Imboden también venció al campeón del mundo de Rusia Alexey Cheremisinov en cuartos de final, por 15-13. En particular, Meinhardt superó al campeón del mundo italiano Andrea Cassara en la ronda 16, por 15-13, y el vigente campeón olímpico italiano Daniele Garozzo fue derrotado en la ronda 32 por el polaco Michal Siess, por 15-7.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 13-arrow" style="top:846px;left:1388px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/10-arrow.png">
      
      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=F&calendar_models_CalendarsCompetition%5BGenderId%5D=&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=GP&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=ITA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:753px;left:61px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      <a href="http://fie.org/" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:906px;left:59px" src="/109/es/static/_content/10-tap-info.png">
      </a>
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax()
          pg13Anim
            .fromTo(cOf("13-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: removeContentLinks}, 1)
        }

        function onPageLeave() {
          pg13Anim.stop()
        }
      `,
      "searchText": "GRAN PREMIO TURÍN, ITALIA 3/3  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA  Pulse aquí para obtener más INFORMACIÓN  Florete femenino Con aproximadamente 170 tiradores en duelo en la prueba de florete individual femenina, el encuentro final contó con la presencia de las compañeras de equipo italianas Alice Volpi y Elisa Di Francisca, que se enfrentaron para conseguir la medalla de oro. La vigente campeona del mundo Volpi derrotó a la campeona del mundo y campeona olímpica Di Francisca por la medalla de oro, por 15-9. Di Francisca venció a otra compañera de equipo, Francesca Palumbo, en la semifinal, por 15-7, mientras que Volpi venció a la rusa Anastasiia Ivanova, por 15-12. Palumbo derrotó a la bicampeona mundial y campeona olímpica Inna Deriglazova en cuartos de final, por 15-5.  Los ocho primeros clasificados en la prueba de florete masculino de los Grandes Premios de Turín incluyeron a Race Imboden (EE. UU., oro), Ka Long Cheung (HKG, plata), Alessio Foconi (ITA, bronce), Gerek Meinhardt (EE. UU., bronce), Alexey Cheremisinov (RUS), Timur Safin (RUS), Alexander Massialas (EE. UU.) y Giorgio Avola (ITA). Las ocho primeras clasificadas incluyeron a Alice Volpi (ITA, oro), Elisa Di Francisca (ITA, plata), Anastasiia Ivanova (RUS, bronce), Francesca Palumbo (ITA, bronce), Inna Deriglazova (RUS), Leonie Ebert (GER), Camilla Mancini (ITA) y Larisa Korobeynikova (RUS). ■ W W W.FIE .ORG",
      "mobileHtml":`
      <p><b>Florete femenino</b></p>
      <p>Con aproximadamente 170 tiradores en duelo en la prueba de florete individual femenina, el encuentro final contó con la presencia de las compañeras de equipo italianas Alice Volpi y Elisa Di Francisca, que se enfrentaron para conseguir la medalla de oro. La vigente campeona del mundo Volpi derrotó a la campeona del mundo y campeona olímpica Di Francisca por la medalla de oro, por 15-9. Di Francisca venció a otra compañera de equipo, Francesca Palumbo, en la semifinal, por 15-7, mientras que Volpi venció a la rusa Anastasiia Ivanova, por 15-12. Palumbo derrotó a la bicampeona mundial y campeona olímpica Inna Deriglazova en cuartos de final, por 15-5.</p>
      <p>Los ocho primeros clasificados en la prueba de florete masculino de los Grandes Premios de Turín incluyeron a Race Imboden (EE. UU., oro), Ka Long Cheung (HKG, plata), Alessio Foconi (ITA, bronce), Gerek Meinhardt (EE. UU., bronce), Alexey Cheremisinov (RUS), Timur Safin (RUS), Alexander Massialas (EE. UU.) y Giorgio Avola (ITA).</p>
      <p>Las ocho primeras clasificadas incluyeron a Alice Volpi (ITA, oro), Elisa Di Francisca (ITA, plata), Anastasiia Ivanova (RUS, bronce), Francesca Palumbo (ITA, bronce), Inna Deriglazova (RUS), Leonie Ebert (GER), Camilla Mancini (ITA) y Larisa Korobeynikova (RUS).</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 14-title" style="top:116px;left:86px" src="/109/es/static/_content/14-title.png">

      <img class="halfScale 14-line" style="top:340px;left:97px" src="/109/es/static/_content/14-line.png">

      <img class="halfScale 14-sub" style="top:339px;left:139px" src="/109/es/static/_content/14-sub.png">

      <img class="halfScale pointer 14-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax()
          pg14Anim
          .fromTo(cOf("14-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("14-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("14-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("14-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg14Anim.stop()
        }
      `,
      "searchText": "GRAN PREMIO  EL ORO EN SABLE DE LOS GRANDES PREMIOS PARA OH DE COREA Y VELIKAYA DE RUSIA EL CAIRO, EGIPTO 24 DE FEBRERO DE 2019",
      "mobileHtml":`
      <h2>EL ORO EN SABLE DE LOS GRANDES PREMIOS PARA OH DE COREA Y VELIKAYA DE RUSIA</h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg14-cairo.jpg">
      <p><b>EL CAIRO, EGIPTO<br>24 DE FEBRERO DE 2019<br>
      </b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 15-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax()
          pg15Anim
            .fromTo(cOf("15-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg15Anim.stop()
        }
      `,
      "searchText": "GRAN PREMIO EL CAIRO, EGIPTO 2/3  La coreana Sanguk Oh y la rusa Sofya Velikaya ganaron medallas de oro individuales en los Grandes Premios de Sable de El Cairo de 2019. Más de 270 tiradores internacionales, hombres y mujeres, compitieron en la prueba, que tuvo lugar en el Estadio de El Cairo. Sable masculino Oh se enfrentó al dos veces medallista de oro olímpico húngaro Aron Szilagyi en el encuentro final de la competencia masculina, ganando con un resultado de 15-10. Szilagyi venció al georgiano Sandro Bazadze en la semifinal, por  15-5, y Oh superó a su compañero de equipo, Junho Kim, por 15-7. Bazadze derrotó al primer clasificado estadounidense Eli Dershwitz en cuartos de final por 15-12, mientras que Dershwitz venció a la campeona del mundo rusa Veniamin Reshetnikov en la ronda 16 por un punto, por 15-14.",
      "mobileHtml":`
      <p><b>La coreana Sanguk Oh y la rusa Sofya Velikaya ganaron medallas de oro individuales en los Grandes Premios de Sable de El Cairo de 2019.</b></p>
      <p>Más de 270 tiradores internacionales, hombres y mujeres, compitieron en la prueba, que tuvo lugar en el Estadio de El Cairo.</p>
      <p><b>Sable masculino</b></p>
      <p>Oh se enfrentó al dos veces medallista de oro olímpico húngaro Aron Szilagyi en el encuentro final de la competencia masculina, ganando con un resultado de 15-10. Szilagyi venció al georgiano Sandro Bazadze en la semifinal, por 15-5, y Oh superó a su compañero de equipo, Junho Kim, por 15-7. Bazadze derrotó al primer clasificado estadounidense Eli Dershwitz en cuartos de final por 15-12, mientras que Dershwitz venció al campeón del mundo ruso Veniamin Reshetnikov en la ronda 16 por un punto, por 15-14.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 16-arrow" style="top:846px;left:1388px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/10-arrow.png">

      <a href="https://fie.us15.list-manage.com/track/click?u=43e998d71622bc3f6aeddee10&id=4c7e1655ec&e=0ff8939683" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:755px;left:61px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      <a href="http://fie.org/" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:909px;left:59px" src="/109/es/static/_content/10-tap-info.png">
      </a>
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax()
          pg16Anim
            .fromTo(cOf("16-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)
        }

        function onPageLeave() {
          pg16Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "GRAN PREMIO EL CAIRO, EGIPTO 3/3  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA  Pulse aquí para obtener más INFORMACIÓN  Sable femenino Sofya Velikaya, dos veces campeona del mundo rusa y dos veces medalla de plata olímpica, se impuso a Sooyeon Choi, de Corea, en la ronda de medallas de oro de la prueba femenina, y terminó con un resultado de 15-12. Choi derrotó a la tricampeona del mundo ucraniana Olga Kharlan por un solo punto en el encuentro de semifinales, por 15-14, mientras que Velikaya anotó la victoria en otro match reñido frente a la francesa Cecilia Berder, por 15-14. En particular, la actual campeona del mundo rusa, Sofia Pozdniakova, derrotó a la dos veces medallista de oro olímpica estadounidense y a la doble campeona del mundo Mariel Zagunis en la ronda 32, por 15-8; Pozdniakova fue entonces superada por la china Yaqi Shao en la ronda 16, por 15-9. Shao perdió ante Kharlan en cuartos de final, por 15-6.  Los ocho primeros clasificados de los Grandes Premios de Sable de El Cairo de 2019 incluyen a Sanguk Oh (KOR, oro), Aron Szilagyi (HUN, plata), Sandro Bazadze (GEO, bronce), Junho Kim (KOR, bronce), Eli Dershwitz (EE. UU.), Max Hartung (GER), Dmitriy Danilenko (RUS) y Vincent Anstett (FRA). Entre los ocho primeros puestos de la clasificación femenina se encuentran Sofya Velikaya (RUS, oro), Sooyeon Choi (KOR, plata), Cecilia Berder (FRA, bronce), Olga Kharlan (UKR, bronce), Anne-Elizabeth Stone (EE. UU.), Liza Pusztai (HUN), Manon Brunet (FRA) y Yaqi Shao (CHN). ■ W W W.FIE .ORG",
      "mobileHtml":`
      <p><b>Sable femenino</b></p>
      <p>Sofya Velikaya, dos veces campeona del mundo rusa y dos veces medalla de plata olímpica, se impuso a Sooyeon Choi, de Corea, en la ronda de medallas de oro de la prueba femenina, y terminó con un resultado de 15-12. Choi derrotó a la tricampeona del mundo ucraniana Olga Kharlan por un solo punto en el encuentro de semifinales, por 15-14, mientras que Velikaya anotó la victoria en otro match reñido frente a la francesa Cecilia Berder, por 15-14. En particular, la actual campeona del mundo rusa, Sofia Pozdniakova, derrotó a la dos veces medallista de oro olímpica estadounidense y a la doble campeona del mundo Mariel Zagunis en la ronda 32, por 15-8; Pozdniakova fue entonces superada por la china Yaqi Shao en la ronda 16, por 15-9. Shao perdió ante Kharlan en cuartos de final, por 15-6.</p>
      <p>Los ocho primeros clasificados de los Grandes Premios de Sable de El Cairo de 2019 incluyen a Sanguk Oh (KOR, oro), Aron Szilagyi (HUN, plata), Sandro Bazadze (GEO, bronce), Junho Kim (KOR, bronce), Eli Dershwitz (EE. UU.), Max Hartung (GER), Dmitriy Danilenko (RUS) y Vincent Anstett (FRA).</p>
      <p>Entre los ocho primeros puestos de la clasificación femenina se encuentran Sofya Velikaya (RUS, oro), Sooyeon Choi (KOR, plata), Cecilia Berder (FRA, bronce), Olga Kharlan (UKR, bronce), Anne-Elizabeth Stone (EE. UU.), Liza Pusztai (HUN), Manon Brunet (FRA) y Yaqi Shao (CHN).</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
        <svg class="abs pulse animatedpulse pointer" onclick="Publish.openVideo('/109/es/static/_content/11-vid.m4v')" style="bottom:460px;left:1146px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
          <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
        </svg>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.allstar.de" target="_blank">
        <img src="/109/es/static/_mobile/17.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      <div class="contentLink" style="bottom:324px;right:1050px;width:264px; height:48px;">
          <a href="https://www.blaise-freres.fr" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
        <img src="/109/es/static/_mobile/18.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 19-title" style="top:115px;left:620px" src="/109/es/static/_content/19-title.png">

      <img class="halfScale 19-line" style="top:349px;left:625px" src="/109/es/static/_content/19-line.png">

      <img class="halfScale 19-sub" style="top:349px;left:667px" src="/109/es/static/_content/19-sub.png">

      <img class="halfScale pointer 19-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax()
          pg19Anim
          .fromTo(cOf("19-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("19-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("19-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("19-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg19Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO  COPA DEL MUNDO DE ESGRIMA SENIOR 2019 12 DE ENERO-10 DE FEBRERO DE 2019",
      "mobileHtml":`

      <h2>COPA DEL MUNDO DE ESGRIMA SENIOR 2019</h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg19-world-cup.jpg">
      <p><b>12 DE ENERO-10 DE FEBRERO DE 2019</b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 20-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax()
          pg20Anim
            .fromTo(cOf("20-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg20Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO ESPADA MASCULINA 2/21  ESPADA MASCULINA HEIDENHEIM, ALEMANIA 12 DE ENERO DE 2019  El esgrimista francés Alexandre Bardenet se ha llevado el oro en la primera copa del mundo de esgrima senior de 2019 en el Heidenheimer Pokal de Heidenheim, Alemania. Cerca de 325 esgrimistas de todo el mundo participaron en la competición de espada masculina. Rusia ganó la medalla de oro de la competición de espada masculina por equipos, la «Copa Voith», en la  que compitieron 37 países. La competición se celebró en el Congress Centrum de Heidenheim. Bardenet derrotó al italiano Davide Di Veroli en la ronda final de la competición individual masculina de espada, por 15-7. En semifinales",
      "mobileHtml":`
      <p><b>ESPADA MASCULINA <br>HEIDENHEIM, ALEMANIA<br>12 DE ENERO DE 2019<br>
      </b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg20-heidenheim.jpg">
      <p>El esgrimista francés Alexandre Bardenet se ha llevado el oro en la primera copa del mundo de esgrima senior de 2019 en el Heidenheimer Pokal de Heidenheim, Alemania. Cerca de 325 esgrimistas de todo el mundo participaron en la competición de espada masculina. Rusia ganó la medalla de oro de la competición de espada masculina por equipos, la «Copa Voith», en la que compitieron 37 países. La competición se celebró en el Congress Centrum de Heidenheim.</p>
      <p>Bardenet derrotó al italiano Davide Di Veroli en la ronda final de la competición individual masculina de espada, por 15-7. En semifinales, Di Veroli venció al japonés Koki Kano en un combate reñido, por 9-8, mientras que Bardenet llegó a la final tras superar al ruso Georgiy Bruev, por 15-11.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 21-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=E&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=GER&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:889px;left:61px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax()
          pg21Anim
            .fromTo(cOf("21-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg21Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO ESPADA MASCULINA 3/21  Di Veroli venció al japonés Koki Kano en un combate reñido, por 9-8, mientras que Bardenet llegó a la final tras superar al ruso Georgiy Bruev, por 15-11.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  En la prueba de espada por equipos masculina, Rusia venció a Hungría en la final, por 35-30. Hungría derrotó a Polonia en la semifinal, por 41-32, mientras que Rusia superó a Italia por un punto, por 45-44. La medalla de bronce se la llevó Italia tras ganar contra Polonia, por 45-31. Los ocho finalistas de la Copa del Mundo del Heidenheimer Pokal fueron Alexandre Bardenet  (FRA, oro), Davide Di Veroli (ITA, plata), Georgiy Bruev (RUS, bronce), Koki Kano (JPN, bronce), Ido Harper (ISR), Gabriele Cimini (ITA), Jacob Hoyle (USA) y David Nagy (HUN). Los ocho mejores equipos clasificados en la competición de espada masculina fueron Rusia (oro), Hungría (plata), Italia (bronce), Polonia, Corea, Estados Unidos, Israel y Suiza.",
      "mobileHtml":`
      <p>En la prueba de espada por equipos masculina, Rusia venció a Hungría en la final, por 35-30. Hungría derrotó a Polonia en la semifinal, por 41-32, mientras que Rusia superó a Italia por un punto, por 45-44. La medalla de bronce se la llevó Italia tras ganar contra Polonia, por 45-31.</p>
      <p>Los ocho finalistas de la Copa del Mundo del Heidenheimer Pokal fueron Alexandre Bardenet (FRA, oro), Davide Di Veroli (ITA, plata), Georgiy Bruev (RUS, bronce), Koki Kano (JPN, bronce), Ido Harper (ISR), Gabriele Cimini (ITA), Jacob Hoyle (USA) y David Nagy (HUN).</p>
      <p>Los ocho mejores equipos clasificados en la competición de espada masculina fueron Rusia (oro), Hungría (plata), Italia (bronce), Polonia, Corea, Estados Unidos, Israel y Suiza.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 22-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax()
          pg20Anim
            .fromTo(cOf("22-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg22Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO FLORETE MASCULINO 4/21  FLORETE MASCULINO PARÍS, FRANCIA 13 DE ENERO DE 2019  El campeón del mundo de esgrima italiano, Alessio Foconi, llevó el oro en la Copa del Mundo de florete masculino del Challenge International de Paris (CIP), mientras que Rusia consiguió el oro en la competición de florete masculino por equipos. La competición, que tuvo lugar en el Stade Pierre de Coubertin, atrajo a más de 250 esgrimistas individuales de primera categoría y a 30 equipos. Foconi se enfrentó al estadounidense Gerek Meinhardt en el último combate y ganó con un resultado de 15-12. Meinhardt venció al italiano Giorgio Avola en la semifinal, por 15-13, mientras que Foconi derrotó al estadounidense Race Imboden, por 15-12. Destaca la victoria de Avola sobre su compañero de equipo y medallista de oro olímpico, Daniele Garozzo, en cuartos de final, por 15-12. En la competición por equipos de florete masculino, Rusia se llevó la medalla de oro frente a Italia, por 45-40. Italia venció a Corea en la semifinal, por 45-33, mientras que Rusia derrotó a Estados Unidos, por 45-36. El equipo de Estados Unidos consiguió la medalla de bronce tras vencer a Corea, por 45-41.",
      "mobileHtml":`
      <p><b>FLORETE MASCULINO<br>
      PARÍS, FRANCIA<br>
      13 DE ENERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg22-paris.jpg">
      <p>El campeón del mundo de esgrima italiano, Alessio Foconi, llevó el oro en la Copa del Mundo de florete masculino del Challenge International de Paris (CIP), mientras que Rusia consiguió el oro en la competición de florete masculino por equipos. La competición, que tuvo lugar en el Stade Pierre de Coubertin, atrajo a más de 250 esgrimistas individuales de primera categoría y a 30 equipos.</p>
      <p>Foconi se enfrentó al estadounidense Gerek Meinhardt en el último combate y ganó con un resultado de 15-12. Meinhardt venció al italiano Giorgio Avola en la semifinal, por 15-13, mientras que Foconi derrotó al estadounidense Race Imboden, por 15-12. Destaca la victoria de Avola sobre su compañero de equipo y medallista de oro olímpico, Daniele Garozzo, en cuartos de final, por 15-12.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 23-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=F&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=FRA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:890px;left:60px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax()
          pg23Anim
            .fromTo(cOf("23-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg23Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO FLORETE MASCULINO 5/21  Los ocho finalistas de la Copa del Mundo de florete masculino del Challenge International de Paris fueron Alessio Foconi (ITA, oro), Gerek Meinhardt (USA, plata), Giorgio Avola (ITA, bronce), Race Imboden (USA, bronce), Daniele Garozzo (ITA), Alexander Massialas (USA), Erwann Le Pechoux (FRA) y Edoardo Luperi (ITA).  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Los ocho países mejor clasificados en la competición de florete masculino por equipos fueron Rusia (oro), Italia (plata), Estados Unidos (bronce), Corea, Francia, Japón, Hong Kong y Polonia.",
      "mobileHtml":`
      <p>En la competición por equipos de florete masculino, Rusia se llevó la medalla de oro frente a Italia, por 45-40. Italia venció a Corea en la semifinal, por 45-33, mientras que Rusia derrotó a Estados Unidos, por 45-36. El equipo de Estados Unidos consiguió la medalla de bronce tras vencer a Corea, por 45-41.</p>
      <p>Los ocho finalistas de la Copa del Mundo de florete masculino del Challenge International de Paris fueron Alessio Foconi (ITA, oro), Gerek Meinhardt (USA, plata), Giorgio Avola (ITA, bronce), Race Imboden (USA, bronce), Daniele Garozzo (ITA), Alexander Massialas (USA), Erwann Le Pechoux (FRA) y Edoardo Luperi (ITA).</p>
      <p>Los ocho países mejor clasificados en la competición de florete masculino por equipos fueron Rusia (oro), Italia (plata), Estados Unidos (bronce), Corea, Francia, Japón, Hong Kong y Polonia.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 24-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax()
          pg24Anim
            .fromTo(cOf("24-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg24Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO FLORETE FEMENINO 6/21  FLORETE FEMENINO KATOWICE, POLONIA 13 DE ENERO DE 2019  La bicampeona del mundo y medallista de oro olímpica rusa Inna Deriglazova ha conseguido la medalla de oro en la Copa del Mundo de florete femenino en Katowice. Cerca de 200 floretistas femeninas de todo el mundo participaron en la competición individual, mientras que Francia se llevó el oro en la competición por equipos, en la que participaron 20 países. La competición tuvo lugar en el Spodek Hall de Katowice.  Deriglazova se impuso a la alemana Leonie Ebert en el combate final de la competición individual de florete femenino y se llevó la medalla de oro con una puntuación final de 13-9. Ebert superó a la estadounidense Lee Kiefer en la semifinal, por 15-12, mientras que Deriglazova derrotó a la bicampeona del mundo italiana Arianna Errigo, por 15-10.",
      "mobileHtml":`
      <p><b>FLORETE FEMENINO<br>KATOWICE, POLONIA<br>13 DE ENERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg24-katowice.jpg">
      <p>La bicampeona del mundo y medallista de oro olímpica rusa Inna Deriglazova ha conseguido la medalla de oro en la Copa del Mundo de florete femenino en Katowice. Cerca de 200 floretistas femeninas de todo el mundo participaron en la competición individual, mientras que Francia se llevó el oro en la competición por equipos, en la que participaron 20 países. La competición tuvo lugar en el Spodek Hall de Katowice.</p>
      <p>Deriglazova se impuso a la alemana Leonie Ebert en el combate final de la competición individual de florete femenino y se llevó la medalla de oro con una puntuación final de 13-9. Ebert superó a la estadounidense Lee Kiefer en la semifinal, por 15-12, mientras que Deriglazova derrotó a la bicampeona del mundo italiana Arianna Errigo, por 15-10.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 25-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=&calendar_models_CalendarsCompetition%5BGenderId%5D=&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=POL&calendar_models_CalendarsCompetition%5BDateBegin%5D=2019-01-01&calendar_models_CalendarsCompetition%5BDateEnd%5D=2019-01-22" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:892px;left:60px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax()
          pg25Anim
            .fromTo(cOf("25-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg25Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO FLORETE FEMENINO 7/21  En la competición por equipos de florete femenino, Francia superó a EE.UU. en la ronda final, por 45-26 y se llevó la medalla de oro. En dos reñidos combates de semifinales, Estados Unidos venció a Rusia, por 45-43, mientras que Francia venció a Italia, por 45-44. La medalla de bronce fue para Italia, por 45-38. Las ocho finalistas de la Copa del Mundo de florete femenino de Katowice fueron Inna Deriglazova (RUS, oro), Leonie Ebert (GER, plata), Arianna Errigo (ITA, bronce), Lee Kiefer (USA, bronce), Pauline Ranvier (FRA), Larisa Korobeynikova (RUS), Anastasiia Ivanova (RUS) y Francesca Palumbo (ITA). Los ocho países mejor clasificados en la competición de florete femenino fueron Francia (oro), Estados Unidos (plata), Italia (bronce), Rusia, Alemania, Canadá, Polonia y Corea.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA",
      "mobileHtml":`
      <p>En la competición por equipos de florete femenino, Francia superó a EE.UU. en la ronda final, por 45-26 y se llevó la medalla de oro. En dos reñidos combates de semifinales, Estados Unidos venció a Rusia, por 45-43, mientras que Francia venció a Italia, por 45-44. La medalla de bronce fue para Italia, por 45-38.</p>
      <p>Las ocho finalistas de la Copa del Mundo de florete femenino de Katowice fueron Inna Deriglazova (RUS, oro), Leonie Ebert (GER, plata), Arianna Errigo (ITA, bronce), Lee Kiefer (USA, bronce), Pauline Ranvier (FRA), Larisa Korobeynikova (RUS), Anastasiia Ivanova (RUS) y Francesca Palumbo (ITA).</p>
      <p>Los ocho países mejor clasificados en la competición de florete femenino fueron Francia (oro), Estados Unidos (plata), Italia (bronce), Rusia, Alemania, Canadá, Polonia y Corea.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 26-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax()
          pg26Anim
            .fromTo(cOf("26-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg26Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO ESPADA FEMENINA 8/21  ESPADA FEMENINA LA HABANA, CUBA 13 DE ENERO DE 2019  La esgrimista de Hong Kong Man Wai Vivian Kong consiguió la medalla de oro individual en la Copa del Mundo de espada femenina de La Habana, tras superar a más de 150 competidoras. Estonia se llevó la medalla de oro de la competición por equipos de espada femenina, en la que participaron 20 países. La competición se celebró en el Coliseo de la Ciudad Deportiva de La Habana.  Kong se enfrentó a la francesa Auriane Mallo en la ronda final y ganó el oro con una puntuación de 15-8. Mallo derrotó a la coreana Young Mi Kang en la semifinal, por 15-9, mientras que Kong se impuso a la italiana Nicol Foietta, por 15-7. Foietta había derrotado a su compañera de equipo y actual campeona del mundo, Mara Navarria, en los cuartos de final, por 15-9.",
      "mobileHtml":`
      <p><b>ESPADA FEMENINA<br>LA HABANA, CUBA<br>13 DE ENERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg26-havana.jpg">
      <p>La esgrimista de Hong Kong Man Wai Vivian Kong consiguió la medalla de oro individual en la Copa del Mundo de espada femenina de La Habana, tras superar a más de 150 competidoras. Estonia se llevó la medalla de oro de la competición por equipos de espada femenina, en la que participaron 20 países. La competición se celebró en el Coliseo de la Ciudad Deportiva de La Habana.</p>
      <p>Kong se enfrentó a la francesa Auriane Mallo en la ronda final y ganó el oro con una puntuación de 15-8. Mallo derrotó a la coreana Young Mi Kang en la semifinal, por 15-9, mientras que Kong se impuso a la italiana Nicol Foietta, por 15-7. Foietta había derrotado a su compañera de equipo y actual campeona del mundo, Mara Navarria, en los cuartos de final, por 15-9.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 27-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=&calendar_models_CalendarsCompetition%5BGenderId%5D=&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=CUB&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:892px;left:60px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax()
          pg27Anim
            .fromTo(cOf("27-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg27Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO ESPADA FEMENINA 9/21  En la competición de espada femenina por equipos, Estonia venció a Polonia en la final, por 34-33. En la semifinal, Polonia vivió otro combate reñido, en el que venció a Rusia por 44-43, mientras que Estonia superó a China, por 45-23. Rusia se llevó la medalla de bronce tras ganar contra China, por 42-35. Las ocho finalistas de la Copa del Mundo de espada femenina de La Habana fueron Man Wai Vivian Kong (HKG, oro), Auriane Mallo (FRA, plata), Nicol Foietta (ITA, bronce), Young Mi Kang  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  (KOR, bronce), Mara Navarria, Violetta Kolobova (RUS), Federica Isola (ITA) y Josephine Jacques Andres Coquin (FRA). Los ocho países mejor clasificados en la competición de espada femenina por equipos fueron Estonia (oro), Polonia (plata), Rusia (bronce), China, Italia, Estados Unidos, Corea y Hungría.",
      "mobileHtml":`
      <p>En la competición de espada femenina por equipos, Estonia venció a Polonia en la final, por 34-33. En la semifinal, Polonia vivió otro combate reñido, en el que venció a Rusia por 44-43, mientras que Estonia superó a China, por 45-23. Rusia se llevó la medalla de bronce tras ganar contra China, por 42-35.</p>
      <p>Las ocho finalistas de la Copa del Mundo de espada femenina de La Habana fueron Man Wai Vivian Kong (HKG, oro), Auriane Mallo (FRA, plata), Nicol Foietta (ITA, bronce), Young Mi Kang (KOR, bronce), Mara Navarria, Violetta Kolobova (RUS), Federica Isola (ITA) y Josephine Jacques Andres Coquin (FRA).</p>
      <p>Los ocho países mejor clasificados en la competición de espada femenina por equipos fueron Estonia (oro), Polonia (plata), Rusia (bronce), China, Italia, Estados Unidos, Corea y Hungría.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 28-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax()
          pg28Anim
            .fromTo(cOf("28-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg28Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO FLORETE FEMENINO 10/21  FLORETE FEMENINO SAINT MAUR, FRANCIA 27 DE ENERO DE 2019  La bicampeona del mundo rusa y la medallista de oro olímpica Inna Deriglazova consiguió la medalla de oro en la Copa del Mundo de florete femenino de Saint Maur, mientras que el equipo francés también ganó el oro en la competición por equipos. La competición, que se celebró en el Centro Deportivo Pierre Brossolette de Saint Maur, contó con la participación de más de 195 floretistas femeninas internacionales y 23 equipos.  Deriglazova se enfrentó a la campeona del mundo italiana Alice Volpi en la final de la competición individual y ganó con una puntuación de 1512. Volpi superó a su compañera de equipo Francesca Palumbo en la semifinal, por 15-11, y Deriglazova venció a la francesa Ysaora Thibus, por 15-12. En la competición de florete femenino por equipos, Francia y Rusia se enfrentaron en la final y las francesas se llevaron el oro, por 41-39. Rusia superó a Italia en la semifinal, por 45-38,",
      "mobileHtml":`
      <p><b>FLORETE FEMENINO<br>SAINT MAUR, FRANCIA<br>27 DE ENERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg28-st-maur.jpg">
      <p>La bicampeona del mundo rusa y la medallista de oro olímpica Inna Deriglazova consiguió la medalla de oro en la Copa del Mundo de florete femenino de Saint Maur, mientras que el equipo francés también ganó el oro en la competición por equipos. La competición, que se celebró en el Centro Deportivo Pierre Brossolette de Saint Maur, contó con la participación de más de 195 floretistas femeninas internacionales y 23 equipos.</p>
      <p>Deriglazova se enfrentó a la campeona del mundo italiana Alice Volpi en la final de la competición individual y ganó con una puntuación de 15-12. Volpi superó a su compañera de equipo Francesca Palumbo en la semifinal, por 15-11, y Deriglazova venció a la francesa Ysaora Thibus, por 15-12.</p>
      <p>En la competición de florete femenino por equipos, Francia y Rusia se enfrentaron en la final y las francesas se llevaron el oro, por 41-39. Rusia superó a Italia en la semifinal, por 45-38, mientras que Francia venció a EE. UU. por un solo punto, por 45-44. Italia se impuso en la ronda por el bronce y derrotó a EE. UU., por 45-37.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 29-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=F&calendar_models_CalendarsCompetition%5BGenderId%5D=F&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=FRA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:892px;left:60px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax()
          pg29Anim
            .fromTo(cOf("29-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg29Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO FLORETE FEMENINO 11/21  mientras que Francia venció a EE. UU. por un solo punto, por 45-44. Italia se impuso en la ronda por el bronce y derrotó a EE. UU., por 45-37. Las ocho finalistas individuales de la Copa del Mundo de florete femenino en Saint Maur fueron Inna Deriglazova (RUS, oro), Alice Volpi (ITA, plata), Francesca Palumbo (ITA, bronce), Ysaora Thibus (FRA, bronce), Svetlana Tripapina (RUS), Adelina Zagidullina (RUS), Jessica Zi Jia Guo (CAN) y Anita Blaze (FRA).  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  Los ocho países finalistas en la competición de florete femenino por equipos fueron Francia (oro), Rusia (plata), Italia (bronce), Estados Unidos, Alemania, Polonia, Japón y Corea.",
      "mobileHtml":`
      <p>Las ocho finalistas individuales de la Copa del Mundo de florete femenino en Saint Maur fueron Inna Deriglazova (RUS, oro), Alice Volpi (ITA, plata), Francesca Palumbo (ITA, bronce), Ysaora Thibus (FRA, bronce), Svetlana Tripapina (RUS), Adelina Zagidullina (RUS), Jessica Zi Jia Guo (CAN) y Anita Blaze (FRA).</p>
      <p>Los ocho países finalistas en la competición de florete femenino por equipos fueron Francia (oro), Rusia (plata), Italia (bronce), Estados Unidos, Alemania, Polonia, Japón y Corea.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:71px;right:320px;width:830px; height:48px;">
          <a href="mailto:service@blue-gauntletservice.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.blue-gauntlet.com" target="_blank">
        <img src="/109/es/static/_mobile/30.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:326px;right:361px;width:169px; height:48px;">
          <a href="https://www.favero.com/es/" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.favero.com" target="_blank">
        <img src="/109/es/static/_mobile/31.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 32-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax()
          pg32Anim
            .fromTo(cOf("32-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg32Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO FLORETE MASCULINO 12/21  FLORETE MASCULINO TOKIO, JAPÓN 27 DE ENERO DE 2019  El británico Richard Kruse se llevó la medalla de oro en la Copa del Mundo de florete masculino del Trofeo Príncipe Takamado en Tokio, mientras que Italia también ganó el oro en la competición por equipos masculina. La competición, que se celebró en el Minato City Sports Center de Tokio, contó con la participación de más de 195 floretistas internacionales masculinos y 21 equipos. Kruse se enfrentó al estadounidense Race Imboden en la final y venció con un marcador de 15-9. Ambos esgrimistas se enfrentaron a  campeones italianos en las semifinales, en las que Imboden venció al campeón del mundo Alessio Foconi, por 15-6, y Kruse al medallista de oro olímpico Daniele Garozzo, por 15-10. Cabe destacar que el cuatro veces campeón del mundo de esgrima alemán Peter Joppich fue derrotado por Imboden en cuartos de final, por 15-7. En la competición de florete por equipos, Italia se enfrentó a Estados Unidos en la final y se llevó la medalla de oro por dos puntos, por 4543. Los estadounidenses derrotaron a Corea",
      "mobileHtml":`
      <p><b>FLORETE MASCULINO<br>TOKIO, JAPÓN<br>27 DE ENERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg32-tokyo.jpg">
      <p>El británico Richard Kruse se llevó la medalla de oro en la Copa del Mundo de florete masculino del Trofeo Príncipe Takamado en Tokio, mientras que Italia también ganó el oro en la competición por equipos masculina. La competición, que se celebró en el Minato City Sports Center de Tokio, contó con la participación de más de 195 floretistas internacionales masculinos y 21 equipos.</p>
      <p>Kruse se enfrentó al estadounidense Race Imboden en la final y venció con un marcador de 15-9. Ambos esgrimistas se enfrentaron a campeones italianos en las semifinales, en las que Imboden venció al campeón del mundo Alessio Foconi, por 15-6, y Kruse al medallista de oro olímpico Daniele Garozzo, por 15-10. Cabe destacar que el cuatro veces campeón del mundo de esgrima alemán Peter Joppich fue derrotado por Imboden en cuartos de final, por 15-7.</p>
      <p>En la competición de florete por equipos, Italia se enfrentó a Estados Unidos en la final y se llevó la medalla de oro por dos puntos, por 45-43. Los estadounidenses derrotaron a Corea en la semifinal, por 45-32, mientras que Italia venció a Rusia, por 45-29. La medalla de bronce fue para Corea tras derrotar a Rusia, por 45-29.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 33-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=F&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=JPN&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:892px;left:61px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax()
          pg33Anim
            .fromTo(cOf("33-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg33Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO FLORETE MASCULINO 13/21  en la semifinal, por 45-32, mientras que Italia venció a Rusia, por 45-29. La medalla de bronce fue para Corea tras derrotar a Rusia, por 45-29. Los ocho finalistas de florete individual masculino en la Copa del Mundo de florete masculino del Trofeo Príncipe Takamado fueron Richard Kruse (GBR, oro), Race Imboden (USA, plata), Alessio Foconi (ITA, bronce), Daniele Garozzo (ITA, bronce), Jun Heo (KOR), Peter Joppich (GER), Timur Arslanov (RUS) y Miles Chamley-Watson (USA).  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Los ocho países finalistas en la competición de florete masculino por equipos fueron Italia (oro), Estados Unidos (plata), Corea (bronce), Rusia, Japón, Francia, Polonia y China.",
      "mobileHtml":`
      <p>Los ocho finalistas de florete individual masculino en la Copa del Mundo de florete masculino del Trofeo Príncipe Takamado fueron Richard Kruse (GBR, oro), Race Imboden (USA, plata), Alessio Foconi (ITA, bronce), Daniele Garozzo (ITA, bronce), Jun Heo (KOR), Peter Joppich (GER), Timur Arslanov (RUS) y Miles Chamley-Watson (USA).</p>
      <p>Los ocho países finalistas en la competición de florete masculino por equipos fueron Italia (oro), Estados Unidos (plata), Corea (bronce), Rusia, Japón, Francia, Polonia y China.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 34-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax()
          pg34Anim
            .fromTo(cOf("34-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg34Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO SABLE FEMENINO 14/21  SABLE FEMENINO SALT LAKE CITY, Utah, EE. UU. 27 DE ENERO DE 2019  Francia se llevó las dos medallas de oro en la Copa del Mundo de sable feminino Absolute Fencing Gear de la FIE de 2019, tanto en la competición individual como por equipos. Celebrada en el Salt Palace Convention Center de Salt Lake City, la competición atrajo a más de 160 esgrimistas femeninas internacionales y a equipos de 18 países. La medalla de oro de sable femenino individual fue para la francesa Cecilia Berder, que venció a la húngara Anna Marton por un solo toque,  por 15-14. Marton superó a la italiana Irene Vecchi en las semifinales, por 15-9, mientras que Berder derrotó a la bicampeona del mundo rusa, Sofia Velikaya, por 15-7. Cabe destacar que la campeona olímpica coreana Jiyeon Kim quedó eliminada en cuartos de final frente a Velikaya, por 15-12, y la vigente campeona del mundo Sofia Pozdniakova fue derrotada por Berder en la misma ronda, por 15-11. En la competición por equipos de sable femenino, Francia venció a Hungría en la ronda",
      "mobileHtml":`
      <p><b>SABLE FEMENINO<br>SALT LAKE CITY, UTAH, EE. UU.<br>27 DE ENERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg34-salt-lake-city.jpg">
      <p>Francia se llevó las dos medallas de oro en la Copa del Mundo de sable femenino Absolute Fencing Gear de la FIE de 2019, tanto en la competición individual como por equipos. Celebrada en el Salt Palace Convention Center de Salt Lake City, la competición atrajo a más de 160 esgrimistas femeninas internacionales y a equipos de 18 países.</p>
      <p>La medalla de oro de sable femenino individual fue para la francesa Cecilia Berder, que venció a la húngara Anna Marton por un solo toque, por 15-14. Marton superó a la italiana Irene Vecchi en las semifinales, por 15-9, mientras que Berder derrotó a la bicampeona del mundo rusa, Sofia Velikaya, por 15-7. Cabe destacar que la campeona olímpica coreana Jiyeon Kim quedó eliminada en cuartos de final frente a Velikaya, por 15-12, y la vigente campeona del mundo Sofia Pozdniakova fue derrotada por Berder en la misma ronda, por 15-11.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 35-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=S&calendar_models_CalendarsCompetition%5BGenderId%5D=F&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=USA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:892px;left:60px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax()
          pg35Anim
            .fromTo(cOf("35-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg35Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO SABLE FEMENINO 15/21  final, por 45-42. Hungría había superado a Italia en las semifinales, por 45-37, y Francia se impuso a China con el mismo resultado, 4537. La medalla de bronce fue para Italia tras derrotar a China, por 45-40. Las ocho finalistas de sable individual femenino en la Copa del Mundo de sable femenino Absolute Fencing Gear de la FIE de 2019 fueron Cecilia Berder (FRA, oro), Anna Marton (HUN, plata), Irene Vecchi (ITA, bronce), Sofya Velikaya  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  (RUS, bronce), Sofia Pozdniakova (RUS), Jiyeon Kim (KOR), Liza Pusztai (HUN) y Theodora Gkountoura (GRE). Los ocho equipos finalistas de sable femenino fueron Francia (oro), Hungría (plata), Italia (bronce), China, Estados Unidos, Corea, Ucrania y Rusia.",
      "mobileHtml":`
      <p>En la competición por equipos de sable femenino, Francia venció a Hungría en la ronda final, por 45-42. Hungría había superado a Italia en las semifinales, por 45-37, y Francia se impuso a China con el mismo resultado, 45-37. La medalla de bronce fue para Italia tras derrotar a China, por 45-40.</p>
      <p>Las ocho finalistas de sable individual femenino en la Copa del Mundo de sable femenino Absolute Fencing Gear de la FIE de 2019 fueron Cecilia Berder (FRA, oro), Anna Marton (HUN, plata), Irene Vecchi (ITA, bronce), Sofya Velikaya (RUS, bronce), Sofia Pozdniakova (RUS), Jiyeon Kim (KOR), Liza Pusztai (HUN) y Theodora Gkountoura (GRE).</p>
      <p>Los ocho equipos finalistas de sable femenino fueron Francia (oro), Hungría (plata), Italia (bronce), China, Estados Unidos, Corea, Ucrania y Rusia.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 36-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax()
          pg36Anim
            .fromTo(cOf("36-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg36Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO SABLE MASCULINO 16/21  SABLE MASCULINO VARSOVIA, POLONIA 3 DE FEBRERO DE 2019  El tirador estadounidense Eli Dershwitz ganó la medalla de oro individual en la 64ª Copa del mundo de Sable masculino “Sabre de Wolodyjowski” de Varsovia, e Italia ganó la medalla de oro de la prueba masculina por equipos. En la competencia, que se celebró en la sede del Comité Olímpico Polaco en Varsovia, participaron unos 220 tiradores de sable masculino y 27 equipos internacionales. Dershwitz se enfrentó al italiano Luca Curatoli en la final, ganando con un resultado de 15-9.  Curatoli derrotó por un escaso margen al alemán Max Hartung en la semifinal, por 15-14, mientras que Dershwitz obtuvo una victoria similar sobre el coreano Sanguk Oh, por 15-14. En particular, Curatoli tuvo una reñida victoria en cuartos de final, por 15-14, frente al campeón mundial ruso Veniamin Reshetnikov. La final de sable masculino por equipos también fue muy reñida, e Italia venció a Francia por la medalla de oro con un solo toque, por 4544. Francia venció a Rusia en la semifinal, por",
      "mobileHtml":`
      <p><b>SABLE MASCULINO<br>VARSOVIA, POLONIA<br>3 DE FEBRERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg36-warsaw.jpg">
      <p>El tirador estadounidense Eli Dershwitz ganó la medalla de oro individual en la 64ª Copa del mundo de Sable masculino «Sabre de Wolodyjowski» de Varsovia, e Italia ganó la medalla de oro de la prueba masculina por equipos. En la competencia, que se celebró en la sede del Comité Olímpico Polaco en Varsovia, participaron unos 220 tiradores de sable masculino y 27 equipos internacionales.</p>
      <p>Dershwitz se enfrentó al italiano Luca Curatoli en la final, ganando con un resultado de 15-9. Curatoli derrotó por un escaso margen al alemán Max Hartung en la semifinal, por 15-14, mientras que Dershwitz obtuvo una victoria similar sobre el coreano Sanguk Oh, por 15-14. En particular, Curatoli tuvo una reñida victoria en cuartos de final, por 15-14, frente al campeón mundial ruso Veniamin Reshetnikov.</p>
      <p>La final de sable masculino por equipos también fue muy reñida, e Italia venció a Francia por la medalla de oro con un solo toque, por 45-44. Francia venció a Rusia en la semifinal, por 45-38, mientras que Italia derrotó a Hungría, por 45-37. Rusia se llevó la medalla de bronce frente a Hungría, por 45-36.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 37-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=S&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=POL&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:892px;left:61px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax()
          pg37Anim
            .fromTo(cOf("37-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg37Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO SABLE MASCULINO 17/21  45-38, mientras que Italia derrotó a Hungría, por 45-37. Rusia se llevó la medalla de bronce frente a Hungría, por 45-36. Las ocho posiciones finales en la prueba individual masculina incluyeron a Eli Dershwitz (EE. UU., oro), Luca Curatoli (ITA, plata), Max Hartung (GER, bronce), Sanguk Oh (KOR, bronce), Bongil Gu (KOR), Kamil Ibragimov (RUS), Veniamin Reshetnikov (RUS) y Jonghyun Lee (KOR). Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  En la prueba masculina por equipos, los ocho primeros clasificados fueron Italia (oro), Francia (plata), Rusia (bronce), Hungría, Corea, Rumanía, Alemania y China.",
      "mobileHtml":`
      <p>Las ocho posiciones finales en la prueba individual masculina incluyeron a Eli Dershwitz (EE. UU., oro), Luca Curatoli (ITA, plata), Max Hartung (GER, bronce), Sanguk Oh (KOR, bronce), Bongil Gu (KOR), Kamil Ibragimov (RUS), Veniamin Reshetnikov (RUS) y Jonghyun Lee (KOR).</p>
      <p>En la prueba masculina por equipos, los ocho primeros clasificados fueron Italia (oro), Francia (plata), Rusia (bronce), Hungría, Corea, Rumanía, Alemania y China.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 38-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg38Anim = new TimelineMax()
          pg38Anim
            .fromTo(cOf("38-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg38Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO ESPADA MASCULINA 18/21  ESPADA MASCULINA VANCOUVER, B.C., CANADÁ 10 DE FEBRERO DE 2019  El japonés Koki Kano se llevó el oro en espada individual masculina en la Copa del mundo Coupe du Monde Peter Bakonyi en Richmond, Columbia Británica, y Rusia anotó el oro en la prueba de espada masculina por equipos. La prueba atrajo a unos 200 espadistas y equipos internacionales masculinos de 23 países, y tuvo lugar en el Óvalo Olímpico de Richmond, una sede de los Juegos Olímpicos de Invierno de Vancouver. Kano se enfrentó al italiano Enrico Garozzo en el encuentro final individual de espada masculina, ganando por 15-7. En la ronda de semifinales, Garozzo venció al estadounidense Jacob Hoyle por un solo toque, por 15-14, y Kano superó al francés Alexandre Bardenet, por 15-8. En",
      "mobileHtml":`
      <p><b>ESPADA MASCULINA<br>VANCOUVER, B.C., CANADÁ<br>10 DE FEBRERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg38-vancouver.jpg">
      <p>El japonés Koki Kano se llevó el oro en espada individual masculina en la Copa del mundo Coupe du Monde Peter Bakonyi en Richmond, Columbia Británica, y Rusia anotó el oro en la prueba de espada masculina por equipos. La prueba atrajo a unos 200 espadistas y equipos internacionales masculinos de 23 países, y tuvo lugar en el Óvalo Olímpico de Richmond, una sede de los Juegos Olímpicos de Invierno de Vancouver.</p>
      <p>Kano se enfrentó al italiano Enrico Garozzo en el encuentro final individual de espada masculina, ganando por 15-7. En la ronda de semifinales, Garozzo venció al estadounidense Jacob Hoyle por un solo toque, por 15-14, y Kano superó al francés Alexandre Bardenet, por 15-8. En cuartos de final, el venezolano Rubén Limardo Gascón, medalla de oro olímpica, también fue eliminado por Garozzo con un solo toque, por 15-14. Cabe destacar que el medallista de oro olímpico coreano Sangyoung Park fue eliminado en la ronda 16 por el francés Romain Cannone, por 15-11, quien fue derrotado por Hoyle en cuartos de final por 15-13.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 39-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=E&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=CAN&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:892px;left:61px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax()
          pg39Anim
            .fromTo(cOf("39-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg39Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO ESPADA MASCULINA 19/21  cuartos de final, el venezolano Rubén Limardo Gascón, medalla de oro olímpica, también fue eliminado por Garozzo con un solo toque, por 15-14. Cabe destacar que el medallista de oro olímpico coreano Sangyoung Park fue eliminado en la ronda 16 por el francés Romain Cannone, por 15-11, quien fue derrotado por Hoyle en cuartos de final por 15-13. Rusia se enfrentó a Israel en la ronda final de la prueba de espada masculina por equipos con un resultado de 45-36. Israel había derrotado a Dinamarca en la ronda de semifinales, por 4542, y Rusia venció a Francia por 45-33. Francia se llevó la medalla de bronce frente a Dinamarca, por 45-32. Los ocho primeros finalistas individuales de la Copa del mundo de Vancouver fueron Koki Kano (JPN, oro), Enrico Garozzo (ITA, plata), Alexandre Bardenet (FRA, bronce), Jacob Hoyle (EE. UU., bronce), Rubén Limardo Gascón (VEN), Dmitriy Alexanin (KAZ), Romain Cannone (FRA) y Federico Vismara (ITA).  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Entre los ocho primeros ganadores de la prueba de espada masculina por equipos se encuentran Rusia (oro), Israel (plata), Francia (bronce), Dinamarca, EE. UU., Ucrania, Alemania y la República Checa.",
      "mobileHtml":`
      <p>Rusia se enfrentó a Israel en la ronda final de la prueba de espada masculina por equipos con un resultado de 45-36. Israel había derrotado a Dinamarca en la ronda de semifinales, por 45-42, y Rusia venció a Francia por 45-33. Francia se llevó la medalla de bronce frente a Dinamarca, por 45-32.</p>
      <p>Los ocho primeros finalistas individuales de la Copa del mundo de Vancouver fueron Koki Kano (JPN, oro), Enrico Garozzo (ITA, plata), Alexandre Bardenet (FRA, bronce), Jacob Hoyle (EE. UU., bronce), Rubén Limardo Gascón (VEN), Dmitriy Alexanin (KAZ), Romain Cannone (FRA) y Federico Vismara (ITA).</p>
      <p>Entre los ocho primeros ganadores de la prueba de espada masculina por equipos se encuentran Rusia (oro), Israel (plata), Francia (bronce), Dinamarca, EE. UU., Ucrania, Alemania y la República Checa.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 40-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax()
          pg40Anim
            .fromTo(cOf("40-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg40Anim.stop()
        }
      `,
      "searchText": "COPA DEL MUNDO ESPADA FEMENINA 20/21  ESPADA FEMENINA BARCELONA, ESPAÑA 10 DE FEBRERO DE 2019  La hongkonesa Man Wai Vivian Kong ganó su segunda copa del mundo de la FIE de manera consecutiva, llevándose el oro en la 43ª edición de la Copa del mundo de Espada femenina “Ciutat de Barcelona”. El equipo polaco se llevó la medalla de oro en espada por equipos. Más de 280 mujeres espadistas y de 29 equipos participaron en la competencia, que tuvo lugar  en el Institut Nacional d’Educació Física de Catalunya (INEFC), sede de los Juegos Olímpicos y Paralímpicos de Barcelona de 1992. Kong se enfrentó a la coreana Hyein Lee en el encuentro final y venció con un resultado de 15-12. Lee venció a la polaca Aleksandra Zamachowska en la semifinal, por 15-7, mientras",
      "mobileHtml":`
      <p><b>ESPADA FEMENINA<br>BARCELONA, ESPAÑA<br>10 DE FEBRERO DE 2019<br></b></p>
      <img id="fwdimg" src="/109/es/static/_mobile/pg40-barcelona.jpg">
      <p>La hongkonesa Man Wai Vivian Kong ganó su segunda copa del mundo de la FIE de manera consecutiva, llevándose el oro en la 43ª edición de la Copa del mundo de Espada femenina «Ciutat de Barcelona». El equipo polaco se llevó la medalla de oro en espada por equipos. Más de 280 mujeres espadistas y de 29 equipos participaron en la competencia, que tuvo lugar en el Institut Nacional d’Educació Física de Catalunya (INEFC), sede de los Juegos Olímpicos y Paralímpicos de Barcelona de 1992.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 41-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/10-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/9-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/9-social-fb.png">
      </a>

      <a href="http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=E&calendar_models_CalendarsCompetition%5BGenderId%5D=F&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=ESP&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:892px;left:60px" src="/109/es/static/_content/10-tap-trophy.png">
      </a>

      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax()
          pg41Anim
            .fromTo(cOf("41-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)
        }

        function onPageLeave() {
          pg41Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "COPA DEL MUNDO ESPADA FEMENINA 21/21  que Kong superó a la estonia Kristina Kuusk, por 15-11. Kong también ganó la copa del mundo de espada femenina el mes pasado en La Habana, Cuba. En la prueba de espada femenina por equipos, Polonia venció a Rusia en la ronda final, por 45-40. Rusia venció a China en semifinales, por 42-36, y Polonia venció a Francia por 36-29. La medalla de bronce fue para China tras derrotar a Francia por 45-38.  Entre las ocho primeras finalistas individuales de la Copa del mundo de Espada femenina de Barcelona se encuentran Man Wai Vivian Kong (HKG, oro), Hyein Lee (KOR, plata), Kristina Kuusk (EST, bronce), Aleksandra Zamachowska (POL, bronce), Kelley Hurley (EE. UU.), Dorina Budai (HUN), Sera Song (KOR) e Isis Washington (EE. UU.). Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  Los ocho países finalistas en la prueba de espada femenina por equipos fueron Polonia (oro), Rusia (plata), China (bronce), Francia, Hungría, EE. UU., Rumanía e Italia. ■ W W W.FIE .ORG",
      "mobileHtml":`
      <p>Kong se enfrentó a la coreana Hyein Lee en el encuentro final y venció con un resultado de 15-12. Lee venció a la polaca Aleksandra Zamachowska en la semifinal, por 15-7, mientras que Kong superó a la estonia Kristina Kuusk, por 15-11. Kong también ganó la copa del mundo de espada femenina el mes pasado en La Habana, Cuba.</p>
      <p>En la prueba de espada femenina por equipos, Polonia venció a Rusia en la ronda final, por 45-40. Rusia venció a China en semifinales, por 42-36, y Polonia venció a Francia por 36-29. La medalla de bronce fue para China tras derrotar a Francia por 45-38.</p>
      <p>Entre las ocho primeras finalistas individuales de la Copa del mundo de Espada femenina de Barcelona se encuentran Man Wai Vivian Kong (HKG, oro), Hyein Lee (KOR, plata), Kristina Kuusk (EST, bronce), Aleksandra Zamachowska (POL, bronce), Kelley Hurley (EE. UU.), Dorina Budai (HUN), Sera Song (KOR) e Isis Washington (EE. UU.).</p>
      <p>Los ocho países finalistas en la prueba de espada femenina por equipos fueron Polonia (oro), Rusia (plata), China (bronce), Francia, Hungría, EE. UU., Rumanía e Italia.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:124px;right:459px;width:310px; height:25px;">
          <a href="http://www.jiangfencing.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:98px;right:459px;width:310px; height:25px;">
          <a href="mailto:jason@jiangfencing.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
        <a href="http://www.jiangfencing.com" target="_blank">
          <img src="/109/es/static/_mobile/42.jpg">
        </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:193px;right:633px;width:180px; height:30px;">
          <a href="http://www.uhlmann-fencing.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:198px;right:844px;width:30px; height:30px;">
          <a href="http://www.facebook.com/UhlmannFechtsport" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:198px;right:813px;width:30px; height:30px;">
          <a href="http://www.instagram.com/Uhlmann.Fencing" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml":`
      <a href="http://www.uhlmann-fencing.com" target="_blank">
          <img src="/109/es/static/_mobile/43.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 44-title" style="top:75px;left:80px" src="/109/es/static/_content/44-title.png">

      <img class="halfScale 44-line" style="top:317px;left:86px" src="/109/es/static/_content/44-line.png">

      <img class="halfScale 44-sub" style="top:314px;left:122px" src="/109/es/static/_content/44-sub.png">

      <img class="halfScale pointer 44-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/44-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg44Anim = new TimelineMax()
          pg44Anim
            .fromTo(cOf("44-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("44-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("44-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("44-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg44Anim.stop()
        }
      `,
      "searchText": "",
      "mobileHtml":`
      <h2>CAMPEONATOS DEL MUNDO DE ESGRIMA JUVENIL Y CADETE DE 2019 EN TORUN</h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg44-torun.jpg">
      <p><b>TORUN, POLONIA <br>6 AL 14 DE ABRIL DE 2019<br></b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 45-arrow" style="top:845px;left:1407px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/44-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/45-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/45-social-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg45Anim = new TimelineMax()
          pg45Anim
            .fromTo(cOf("45-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg45Anim.stop()
        }
      `,
      "searchText": "",
      "mobileHtml":`
      <p><b>Los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2019 en Torun están preparados para recibir a varios miles de visitantes en Polonia en abril, incluidos los tiradores y sus entrenadores, aficionados y simpatizantes.</b></p>
      <p>Los Campeonatos reúnen a atletas adolescentes de docenas de países para competir en 18 pruebas: De las dos categorías de edad de los jóvenes que compiten, hombres y mujeres, cadetes y juveniles, los cadetes más jóvenes participarán en seis pruebas individuales con las tres armas (florete, espada y sable), y los juveniles también participarán en seis pruebas individuales y en seis torneos por equipos. Todos ellos se celebrarán en el Arena Sports Hall de Torun durante nueve días, del 6 al 14 de abril.</p>
      <p>Los Campeonatos del Mundo de Esgrima Juvenil y Cadete del año pasado se celebraron en Verona, Italia, donde participó un número récord de atletas. Una vez más, este año la FIE espera reunir cifras iguales o superiores de jóvenes tiradores participantes, todos dispuestos a conseguir medallas de oro, así como de pasar tiempo con viejos y nuevos amigos de todo el mundo.  </p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 46-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/46-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/45-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/45-social-fb.png">
      </a>

      <a href="https://www.FencingTorun2019.com" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:790px;left:57px" src="/109/es/static/_content/46-tap-info.png">
      </a>

      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg46Anim = new TimelineMax()
          pg46Anim
            .fromTo(cOf("46-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)
        }

        function onPageLeave() {
          pg46Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JÚNIOR Y CADETE TORUN, POLONIA 2/3  Los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2019 en Torun están preparados para recibir a varios miles de visitantes en Polonia en abril, incluidos los tiradores y sus entrenadores, aficionados y simpatizantes. Los Campeonatos reúnen a atletas adolescentes de docenas de países para competir en 18 pruebas: De las dos categorías de edad de los jóvenes que compiten, hombres y mujeres, cadetes y juveniles, los cadetes más jóvenes participarán en seis pruebas individuales con las tres armas (florete, espada y sable), y los juveniles también participarán en seis pruebas individuales y en seis torneos por equipos. Todos ellos se celebrarán en el Arena Sports Hall de Torun durante nueve días, del 6 al 14 de abril. Los Campeonatos del Mundo de Esgrima Juvenil y Cadete del año pasado se celebraron en Verona, Italia, donde participó un número récord de atletas. Una vez más, este año la FIE espera reunir cifras iguales o superiores de jóvenes tiradores participantes, todos dispuestos a conseguir medallas de oro, así como de pasar tiempo con viejos y nuevos amigos de todo el mundo.  Habrá disponibles varios programas en Torun para los atletas, incluida la oportunidad de traer su equipo de esgrima usado y de concederlo al programa de la FIE “Donate Your Fencing Gear!”, beneficiando a las federaciones y tiradores en desarrollo y desfavorecidos. Se pondrán a disposición de todos presentaciones y programas educativos sobre la lucha contra el dopaje y la protección de los atletas, así como",
      "mobileHtml":`
      <p>Habrá disponibles varios programas en Torun para los atletas, incluida la oportunidad de traer su equipo de esgrima usado y de concederlo al programa de la FIE «Donate Your Fencing Gear!», beneficiando a las federaciones y tiradores en desarrollo y desfavorecidos. Se pondrán a disposición de todos presentaciones y programas educativos sobre la lucha contra el dopaje y la protección de los atletas, así como exposiciones en las que se presentarán numerosos vendedores de equipos y promociones.</p>
      <p>Además de la esgrima, los visitantes de los Campeonatos del Mundo conocerán una ciudad histórica, de cuento de hadas, con un patrimonio y una cultura ricos, y con muchas actividades y experiencias que ofrecer. Torun es una de las ciudades más antiguas de Polonia y, la famosa Ciudad Medieval de Turín, Patrimonio de la Humanidad de la UNESCO, se encuentra a poca distancia de los Campeonatos del Mundo. La ciudad también es famosa por sus tartas de jengibre (desde el siglo XIV), y su colorida arquitectura gótica y su panorama nocturno se consideran una de las siete maravillas de Polonia. El famoso astrónomo Nicolás Copérnico nació en Torun.  </p>
      <p>El Arena Sports Hall de Torun, sede de las pruebas, está considerado como la única instalación de este tipo en Polonia, capaz de albergar un acontecimiento tan grande como el de los Campeonatos del Mundo de Esgrima Juvenil y Cadete. Este moderno y polivalente recinto de deportes y entretenimiento se inauguró oficialmente en agosto de 2014, con iluminación de última generación, amenidades, suelos para pruebas y asientos. También está habilitado para la transmisión de televisión y para la cobertura adecuada de los medios de comunicación en pruebas de clase mundial.</p>
      <p>More information about the competition, the venue, and the city of Torun is available on the official web site, <a href="https://www.FencingTorun2019.com">www.FencingTorun2019.com.</a></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:330px;right:898px;width:620px; height:54px;">
          <a href="http://www.fencewithfun.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:180px;right:964px;width:210px; height:27px;">
          <a href="http://www.fencewithfun.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:180px;right:1240px;width:220px; height:27px;">
          <a href="mailto:info@fencewithfun.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.fencewithfun.com" target="_blank">
        <img src="/109/es/static/_mobile/47.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:143px;right:40px;width:720px; height:48px;">
          <a href="http://www.absolutefencinggear.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.absolutefencinggear.com" target="_blank">
        <img src="/109/es/static/_mobile/48.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 49-title" style="top:22px;left:71px" src="/109/es/static/_content/49-title.png">

      <img class="halfScale 49-name-1" style="top:647px;left:-354px" src="/109/es/static/_content/49-name-1.png">
      <img class="halfScale 49-name-2" style="top:773px;left:359px" src="/109/es/static/_content/49-name-2.png">

      <img class="halfScale pointer 49-arrow" style="top:949px;left:1409px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/49-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg49Anim = new TimelineMax()
          pg49Anim
            .fromTo(cOf("49-title"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)
            .fromTo(cOf("49-name-1"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1},"-=0.2")
            .fromTo(cOf("49-name-2"), 0.4,{x:200,opacity:0}, {x:0,opacity:1},"-=0.1")
            .fromTo(cOf("49-arrow"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, "-=0.1")
        }

        function onPageLeave() {
          pg49Anim.stop()
        }
      `,
      "searchText": "CONOZCA A LOS ATLE TAS  			 YUKA 						 UENO",
      "mobileHtml":`
      <h2>CONOZCA A LOS ATLETAS</h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg49-meet.jpg">
      <h4>YUKA UENO</h4>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": `
      <img id="50-next" class="halfScale pointer" style="top:949px;left:648px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/50-arrow.png">

      <img id="50-no-1" class="halfScale 50-questions" style="top:418px;left:728px" src="/109/es/static/_content/50-1.png">
      <img id="50-no-2" class="halfScale 50-questions" style="top:418px;left:730px; display: none;" src="/109/es/static/_content/50-2.png">
      <img id="50-no-3" class="halfScale 50-questions" style="top:418px;left:728px; display: none;" src="/109/es/static/_content/50-3.png">
      <img id="50-no-4" class="halfScale 50-questions" style="top:418px;left:728px; display: none;" src="/109/es/static/_content/50-4.png">
      <img id="50-no-5" class="halfScale 50-questions" style="top:418px;left:728px; display: none;" src="/109/es/static/_content/50-5.png">
      <img id="50-no-6" class="halfScale 50-questions" style="top:418px;left:728px; display: none;" src="/109/es/static/_content/50-6.png">
      <img id="50-no-7" class="halfScale 50-questions" style="top:418px;left:728px; display: none;" src="/109/es/static/_content/50-7.png">

      <div class="addContentLink" style="top: 443px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('50-no-1')"></div>
      <div class="addContentLink" style="top: 538px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('50-no-2')"></div>
      <div class="addContentLink" style="top: 629px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('50-no-3')"></div>
      <div class="addContentLink" style="top: 722px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('50-no-4')"></div>
      <div class="addContentLink" style="top: 813px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('50-no-5')"></div>
      <div class="addContentLink" style="top: 907px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('50-no-6')"></div>
      <div class="addContentLink" style="top: 1000px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('50-no-7')"></div>
      `,
      "script": `
      function onPageEnter() {
        pg50Anim = new TimelineMax()
        pg50Anim.fromTo(idOf("50-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function swapQuestion(ele) {
        var x = cOf("50-questions");
        var i;
        for (i = 0; i < x.length; i++) {
          x[i].style.display = 'none';
        }
        idOf(ele).style.display = ""
      }

      function onPageLeave() {
        pg50Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "La japonesa de 17 años, Yuka Ueno, se proclamó campeona en 2018 en los Campeonatos del Mundo de Esgrima Juvenil y Cadete de Verona en la categoría de florete femenino juvenil, y de nuevo en los Juegos Olímpicos Juveniles de Buenos Aires. Como una de las estrellas en ascenso en esgrima mundial juvenil y senior, este año defenderá su título en los Campeonatos del Mundo Juvenil y Cadete de Esgrima de Torun. ¿Cómo se convirtió en tiradora? Mis padres son tiradores, y me pareció que la esgrima era divertida; empecé cuando tenía seis años.  1 2 3 4 5 6 7",
      "mobileHtml":`
      <p><b>La japonesa de 17 años, Yuka Ueno, se proclamó campeona en 2018 en los Campeonatos del Mundo de Esgrima Juvenil y Cadete de Verona en la categoría de florete femenino juvenil, y de nuevo en los Juegos Olímpicos Juveniles de Buenos Aires. Como una de las estrellas en ascenso en esgrima mundial juvenil y senior, este año defenderá su título en los Campeonatos del Mundo Juvenil y Cadete de Esgrima de Torun.</b></p>
      <br>

      <p><b>¿Cómo se convirtió en tiradora? </b></p>
      <p>YU: Mis padres son tiradores, y me pareció que la esgrima era divertida; empecé cuando tenía seis años. </p>

      <p><b>¿Qué o quién ha representado la mayor influencia en su vida como tiradora?</b></p>
      <p>YU: Mi padre, que me enseñó esgrima muy en serio, para convertirme en una buena tiradora.</p>

      <p><b>¿Qué prueba fue su mejor experiencia? </b></p>
      <p>YU:  Los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2018 en Verona (donde Yuka ganó el oro).</p>

      <p><b>¿Cómo es la esgrima en Japón? </b></p>
      <p>YU:  Me proporcionan un apoyo muy bueno, incluidas las instalaciones de entrenamiento.</p>

      <p><b>¿Cómo fue su temporada 2017-2018?</b></p>
      <p>YU:  Aunque algunos de los resultados fueron buenos, no me resultó magnífica, ya que considero que no jugué tan bien como se había esperado.</p>

      <p><b>¿Cuál es su sueño en la esgrima, su mayor ambición?</b></p>
      <p>YU: Ganar una medalla de oro en los Juegos Olímpicos.</p>

      <p><b>¿Cuál es su mensaje para las aspirantes a tiradoras?  </b></p>
      <p>YU:  ¡Alcanza las metas que te has propuesto! </p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:391px;right:771px;width:210px; height:33px;">
          <a href="http://es.gfencing.com/" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:391px;right:550px;width:210px; height:33px;">
          <a href="mailto:sales@gfencing.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "mobileHtml":`
        <a href="http://www.gfencing.com" target="_blank">
          <img src="/109/es/static/_mobile/51.jpg">
        </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 52-title" style="top:234px;left:624px" src="/109/es/static/_content/52-title.png">

      <img class="halfScale 52-line" style="top:412px;left:623px" src="/109/es/static/_content/52-line.png">

      <img class="halfScale 52-sub" style="top:412px;left:658px" src="/109/es/static/_content/52-sub.png">

      <img class="halfScale pointer 52-arrow" style="top:845px;left:1409px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/52-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg52Anim = new TimelineMax()
          pg52Anim
            .fromTo(cOf("52-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("52-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("52-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("52-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg52Anim.stop()
        }
      `,
      "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  CLASES DE ESGRIMA CON LOS EXPERTOS BANSKO, BULGARIA 24 DE ENERO DE 2019",
      "mobileHtml":`
      <h2>CLASES DE ESGRIMA CON LOS EXPERTOS</h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg52-learning.jpg">
      <p><b>BANSKO, BULGARIA<br>24 DE ENERO DE 2019<br></b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 53-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/53-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/53-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/53-social-fb.png">
      </a>

      <a href="http://www.internationalfencingcamp.org/" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:881px;left:59px" src="/109/es/static/_content/53-tap-info.png">
      </a>

      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg53Anim = new TimelineMax()
          pg53Anim
            .fromTo(cOf("53-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)
        }

        function onPageLeave() {
          pg53Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  Este verano se celebrará un campamento de espada en Bansko, Bulgaria, del 29 de julio al 5 de agosto, que ofrecerá a los jóvenes atletas de todo el mundo la oportunidad de trabajar directamente con medallistas de los Juegos Olímpicos y del Campeonato del Mundo.  Pulse aquí para obtener más INFORMACIÓN  El Campamento Internacional de Esgrima está abierto a esgrimistas principiantes, de nivel intermedio y de élite, niños y niñas, de las categorías sub-12 (2010-2007), sub-15 (20062004) y sub-18 (2003-2001). En el campamento con una duración de seis días participarán Rubén Limardo-Gascón (VEN, medalla de oro olímpica, Londres 2012), Nikolai Novosjolov (EST, dos veces campeón del mundo) y Ana María Popescu (ROU, medalla de plata olímpica, Pekín 2008). El campamento ofrecerá un curso diverso de técnicas y prácticas de entrenamiento de espada, así como valoraciones individuales y grupales y apoyo de los campeones de espada.  Además de las actividades de esgrima, Bansko es una zona muy rica culturalmente, situada al pie del Parque Nacional de Pirin, declarado Patrimonio de la Humanidad por la UNESCO. Esta moderna región ofrece una amplia variedad de opciones para explorar la naturaleza y la historia, así como las atracciones recreativas. Bansko está a unas dos horas en coche al sur de Sofía. Organizado por la Academia de Esgrima MK y el Club de Esgrima de Sofía, el evento también está asociado con la Federación Búlgara de Esgrima. La inscripción anticipada (con descuento) está disponible hasta el 31 de marzo. ■ W W W.FIE .ORG",
      "mobileHtml":`
      <p><b>Este verano se celebrará un campamento de espada en Bansko, Bulgaria, del 29 de julio al 5 de agosto, que ofrecerá a los jóvenes atletas de todo el mundo la oportunidad de trabajar directamente con medallistas de los Juegos Olímpicos y del Campeonato del Mundo.</b></p>
      <p>El Campamento Internacional de Esgrima está abierto a esgrimistas principiantes, de nivel intermedio y de élite, niños y niñas, de las categorías sub-12 (2010-2007), sub-15 (2006-2004) y sub-18 (2003-2001). En el campamento con una duración de seis días participarán Rubén Limardo-Gascón (VEN, medalla de oro olímpica, Londres 2012), Nikolai Novosjolov (EST, dos veces campeón del mundo) y Ana María Popescu (ROU, medalla de plata olímpica, Pekín 2008). El campamento ofrecerá un curso diverso de técnicas y prácticas de entrenamiento de espada, así como valoraciones individuales y grupales y apoyo de los campeones de espada.</p>
      <p>Además de las actividades de esgrima, Bansko es una zona muy rica culturalmente, situada al pie del Parque Nacional de Pirin, declarado Patrimonio de la Humanidad por la UNESCO. Esta moderna región ofrece una amplia variedad de opciones para explorar la naturaleza y la historia, así como las atracciones recreativas. Bansko está a unas dos horas en coche al sur de Sofía.
      Organizado por la Academia de Esgrima MK y el Club de Esgrima de Sofía, el evento también está asociado con la Federación Búlgara de Esgrima. La inscripción anticipada (con descuento) está disponible hasta el 31 de marzo.</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
        <img src="/109/es/static/_mobile/54.png">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 54,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg55.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 55-title" style="top:89px;left:85px" src="/109/es/static/_content/55-title.png">

      <img class="halfScale 55-line" style="top:267px;left:848px" src="/109/es/static/_content/55-line.png">

      <img class="halfScale 55-sub" style="top:267px;left:884px" src="/109/es/static/_content/55-sub.png">

      <img class="halfScale pointer 55-arrow" style="top:845px;left:1409px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/55-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg55Anim = new TimelineMax()
            pg55Anim
              .fromTo(cOf("55-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
              .fromTo(cOf("55-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
              .fromTo(cOf("55-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
              .fromTo(cOf("55-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg55Anim.stop()
        }
      `,
      "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  EL PROYECTO DE ESGRIMA DE ECUADOR AYUDA A LOS NIÑOS QUITO, ECUADOR DESFAVORECIDOS 31 DE ENERO DE 2019",
      "mobileHtml":`
      <h2>EL PROYECTO DE ESGRIMA DE ECUADOR AYUDA A LOS NIÑOS DESFAVORECIDOS</h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg55-ecuador.jpg">
      <p><b>QUITO, ECUADOR<br>31 DE ENERO DE 2019<br></b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 55,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg56.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 56-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/109/es/static/_content/53-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/109/es/static/_content/53-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/109/es/static/_content/53-social-fb.png">
      </a>

      <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg56Anim = new TimelineMax()
          pg56Anim
            .fromTo(cOf("56-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)
        }

        function onPageLeave() {
          pg56Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 2  “NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  «Cuesta encontrar clases de esgrima a las que asistan 50 participantes en Quito, pero aquí hemos alcanzado esa cifra», explicó Diego Portilla, campeón nacional de sable en varias ocasiones y responsable del proyecto presentado por la EFF, en el marco del programa «DONATE YOUR FENCING GEAR» 2018 de la FIE, implementado en colaboración con el Ayuntamiento de Quito. Los niños más desfavorecidos reciben clases de esgrima gracias a la contribución de los donantes de «DONATE YOUR FENCING GEAR». «Acogemos a más de 250 niños, pero de momento solo tenemos material para unos 50», dijo Portilla. «Esperamos aumentar la cuota fija de participantes en un futuro próximo, así como la frecuencia de las clases, que hasta ahora ha estado limitada a una por semana». Los niños entrenan con los equipos provinciales y nacionales, de modo que la Federación Nacional en su conjunto (entrenadores de atletas, árbitros y directivos) se involucra activamente en el proyecto.  «Con la esgrima podemos enseñar a los niños muchas cosas», explicó Portilla, que también es una hábil psicólogo especializado en terapia sistémica. «Lo primero que aprenden es autocontrol, porque en la esgrima, si no te controlas, pierdes. También aprenden a respetar al oponente». «Los entrenadores involucrados en el proyecto son todos entrenadores nacionales o árbitros que también trabajan en clubes de esgrima locales», concluyó Lorena Arroyo, Presidenta de la Federación Ecuatoriana de Esgrima, al final de la visita. «La esperanza es que de este grupo surjan jóvenes talentos que sigan con su carrera deportiva en uno de los clubes en caso de que deseen incorporarse. No descartamos que un día lleguen a ser seleccionados para la selección nacional». ■ W W W.FIE .ORG",
      "mobileHtml":`
      <p><b>«Cuesta encontrar clases de esgrima a las que asistan 50 participantes en Quito, pero aquí hemos alcanzado esa cifra», explicó Diego Portilla, campeón nacional de sable en varias ocasiones y responsable del proyecto presentado por la EFF, en el marco del programa «DONATE YOUR FENCING GEAR» 2018 de la FIE, implementado en colaboración con el Ayuntamiento de Quito.</b></p>
      <p>Los niños más desfavorecidos reciben clases de esgrima gracias a la contribución de los donantes de «DONATE YOUR FENCING GEAR».</p>
      <p>«Acogemos a más de 250 niños, pero de momento solo tenemos material para unos 50», dijo Portilla. «Esperamos aumentar la cuota fija de participantes en un futuro próximo, así como la frecuencia de las clases, que hasta ahora ha estado limitada a una por semana». Los niños entrenan con los equipos provinciales y nacionales, de modo que la Federación Nacional en su conjunto (entrenadores de atletas, árbitros y directivos) se involucra activamente en el proyecto.</p>
      <p>«Con la esgrima podemos enseñar a los niños muchas cosas», explicó Portilla, que también es una hábil psicólogo especializado en terapia sistémica. «Lo primero que aprenden es autocontrol, porque en la esgrima, si no te controlas, pierdes. También aprenden a respetar al oponente».</p>
      <p>«Los entrenadores involucrados en el proyecto son todos entrenadores nacionales o árbitros que también trabajan en clubes de esgrima locales», concluyó Lorena Arroyo, presidenta de la Federación Ecuatoriana de Esgrima, al final de la visita. «La esperanza es que de este grupo surjan jóvenes talentos que sigan con su carrera deportiva en uno de los clubes en caso de que deseen incorporarse. No descartamos que un día lleguen a ser seleccionados para la selección nacional».</p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 56,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg57.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:56px;right:625px;width:290px; height:47px;">
          <a href="http://www.pbtfencing.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:56px;right:65px;width:331px; height:47px;">
          <a href="http://www.instagram.com/pbt_fencing/" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:56px;right:1185px;width:290px; height:47px;">
          <a href="mailto:sales@pbtfencing.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
        <a href="http://www.pbtfencing.com" target="_blank">
          <img src="/109/es/static/_mobile/57.jpg">
        </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 57,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg58.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
        <img src="/109/es/static/_mobile/58.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 58,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg59.jpg",
      "zoom": null,
      "content": `
        <img id="59-title" class="halfScale" style="top:132px;left:83px" src="/109/es/static/_content/59-title.png">
        <a href="http://fie.org/es?no-redirect=" target="_blank">
          <img id="59-logo" class="halfScale" style="top:106px;left:1271px" src="/109/es/static/_content/59-logo.png">
        </a>
        <img id="59-next" class="halfScale pointer" style="top:938px;left:1174px" src="/109/es/static/_content/59-arrow.png">

        <a href="http://fie.org/es?no-redirect=" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <div class="addContentLink" style="top: 433px; left: 134px; width: 230px; height: 34px;" onclick="showOverlay('59-pop-1')"></div>
        <div id="59-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img id="" class="halfScale" style="top:0px;left:0px" src="/109/es/static/_content/59-pop-1.jpg">
          <div class="addContentLink" style="top: 63px; left: 1339px; width: 135px; height: 49px;opacity:0" onclick="hideOverlay('59-pop-1');"></div>
        </div>

        <div class="addContentLink" style="top: 662px; left: 1042px; width: 147px; height: 62px;" onclick="showOverlay('59-pop-2')"></div>
        <div id="59-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img id="" class="halfScale" style="top:0px;left:0px" src="/109/es/static/_content/59-pop-2.jpg">
          <div class="addContentLink" style="top: 51px; left: 1320px; width: 172px; height: 49px;opacity:0" onclick="hideOverlay('59-pop-2');"></div>
        </div>
        `,
      "script": `
        function onPageEnter() {
          pg59Anim = new TimelineMax()
          pg59Anim.fromTo(idOf("59-title"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)
            .fromTo(idOf("59-logo"), 0.3,{opacity:0}, {opacity:1},"-=0.2")
            .fromTo(idOf("59-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, "-=0.2")
        } 

        function onPageLeave() {
          pg59Anim.stop();
          removeContentLinks();
          hideOverlay('59-pop-1');
          hideOverlay('59-pop-2');
        }
      `,
      "searchText": "NOTICIAS  NOTICIAS DE LA FIE 1   Se anuncia la Prueba test de esgrima olímpica Ver más aquí.  WWW.FIE.ORG  2  Peter Jacobs recibe el Premio de Honor del Imperio Británico Ver más aquí.  W W W.FIE .ORG",
      "mobileHtml":`
      <h2>NOTICIAS DE LA FIE</h2>
      <img id="fwdimg" src="/109/es/static/_mobile/pg59-news.jpg">
      <p><b>PETER JACOBS AWARDED BRITISH EMPIRE HONOUR</b></p>
      <p>Peter Jacobs recibe el Premio de Honor del Imperio Británico
      Ver más aquí.</p>
      <p>El anuncio forma parte de la programación general de las Pruebas test «Ready Steady Tokyo», que incluye pruebas de ensayo general con la intención de garantizar el éxito durante los Juegos Olímpicos. Están organizados por federaciones internacionales y nacionales (FI/FN), así como por el Comité Organizador de Tokio 2020. De las cincuenta y seis pruebas test, algunas se celebrarán durante las pruebas deportivas de FI/FN, y otras 22 se organizarán antes de Tokio 2020.</p>
      <p>La prueba test de esgrima tendrá lugar del 13 al 15 de diciembre de 2019 en el marco de la Copa del mundo de Florete y del Trofeo Príncipe Takamado de la FIE. Tendrá lugar en el Makuhari Messe (Sala B), uno de los centros de convenciones más grandes de Japón, situado en la ciudad de Chiba, Prefectura de Chiba. En varias salas se celebrarán esgrima, taekwondo y lucha libre durante los Juegos Olímpicos de Tokio 2020.</p>
      `,
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": [
      {
        "title": "Escrime XXI N⁰. 109",
        "cssClass": "cover mobile-p1",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 0,
          "subIndex": 0
        }]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 2,
          "subIndex": 0
        }]
      },
      {
        "title": "Comité Ejecutivo de la FIE",
        "cssClass": "aqua",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 4,
          "subIndex": 0
        }]
      },
      {
        "title": "Prólogo",
        "cssClass": "aqua",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 5,
          "subIndex": 0
        }]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 6,
          "subIndex": 0
        }]
      },
      {
        "title": "Doha",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 7,
            "subIndex": 0
          },
          {
            "index": 8,
            "subIndex": 0
          },
          {
            "index": 9,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Turín",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 10,
            "subIndex": 0
          },
          {
            "index": 11,
            "subIndex": 0
          },
          {
            "index": 12,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "El Cairo",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 13,
            "subIndex": 0
          },
          {
            "index": 14,
            "subIndex": 0
          },
          {
            "index": 15,
            "subIndex": 0
          },
        ]
      },
      
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 16,
          "subIndex": 0
        }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 17,
          "subIndex": 0
        }]
      },

      {
        "title": "Copa del Mundo",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 18,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - Heidenheim",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 19,
            "subIndex": 0
          },
          {
            "index": 20,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - París",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 21,
            "subIndex": 0
          },
          {
            "index": 22,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - Katowice",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 23,
            "subIndex": 0
          },
          {
            "index": 24,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - La Habana",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 25,
            "subIndex": 0
          },
          {
            "index": 26,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - Saint Maur",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 27,
            "subIndex": 0
          },
          {
            "index": 28,
            "subIndex": 0
          }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 29,
          "subIndex": 0
        }]
      },
      
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 30,
          "subIndex": 0
        }]
      },

      {
        "title": "Copa del Mundo - Tokio",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 31,
            "subIndex": 0
          },
          {
            "index": 32,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - Salt Lake City",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 33,
            "subIndex": 0
          },
          {
            "index": 34,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - Varsovia",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 35,
            "subIndex": 0
          },
          {
            "index": 36,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - Vancouver, B.C.",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 37,
            "subIndex": 0
          },
          {
            "index": 38,
            "subIndex": 0
          }]
      },

      {
        "title": "Copa del Mundo - Barcelona",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 39,
            "subIndex": 0
          },
          {
            "index": 40,
            "subIndex": 0
          }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 41,
          "subIndex": 0
        }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 42,
          "subIndex": 0
        }]
      },

      {
        "title": "Vista Previa",
        "cssClass": "purple",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 43,
            "subIndex": 0
          },
          {
            "index": 44,
            "subIndex": 0
          },
          {
            "index": 45,
            "subIndex": 0
          }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 46,
          "subIndex": 0
        }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 47,
          "subIndex": 0
        }]
      },

      {
        "title": "Conozca a los Atletas - Yuka Ueno",
        "cssClass": "aqua",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 48,
          "subIndex": 0
        },
        {
          "index": 49,
          "subIndex": 0
        }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 50,
          "subIndex": 0
        }]
      },

      {
        "title": "Noticias de la FIE y de las Federaciónes Nacionales",
        "cssClass": "green",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 51,
          "subIndex": 0
        },
        {
          "index": 52,
          "subIndex": 0
        }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 53,
          "subIndex": 0
        }]
      },

      {
        "title": "El Proyecto de Esgrima",
        "cssClass": "green",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 54,
          "subIndex": 0
        },
        {
          "index": 55,
          "subIndex": 0
        }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 56,
          "subIndex": 0
        }]
      },

      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 57,
          "subIndex": 0
        }]
      },

      {
        "title": "Noticias",
        "cssClass": "yellow",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 58,
          "subIndex": 0
        }]
      },
    ],
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js